import React, { useEffect, useState, useRef, Component } from 'react';
import './gifting.css';
import { GiftingProduct, SelectedOption } from '../../product/@types';
import { OptionKeys, Product, VariantsEntity } from '../../cart/@types';
import { fetchCart, updateIconCount } from '../../product/utils';
import ProductOptionsModal from './modal';
import { Disclosure } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import Popup from '../../product/components/Popup';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, FreeMode } from 'swiper/modules';
import 'swiper/swiper-bundle.css';

import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const shop = 'sitikhadijahstore.myshopify.com';
const api =
  process.env.NODE_ENV !== 'development'
    ? 'https://asia-southeast1-enda-combine-stock-shopify-app.cloudfunctions.net'
    : process.env.NGROK_DEV;

interface CartGifting {
  mainGift?: { variantId: number; productId: number | undefined }[];
  accessoriesGift?: { variantId: number; productId: number | undefined }[];
  wishCardGift?: {
    variantId?: number;
    productId?: number | undefined;
    message?: string;
    recipientName?: string;
  }[];
  boxGift?: { variantId: number; productId: number | undefined }[];
  wrappingGift?: { variantId: number; productId: number | undefined }[];
}
export type GiftType = 'mainGift' | 'accessoriesGift' | 'wishCardGift' | 'boxGift' | 'wrappingGift';
interface ChooseProductProps {
  productData: GiftingProduct[][];
  totalPrice: number;
  onBack: () => void;
  onNextStep: (giftId: string) => void;
  onGiftChange: (
    variantId: number,
    productId: number | undefined,
    type: GiftType,
    index: number,
  ) => void;
  productColourSwatches: string[];
  giftingCart: CartGifting;
  setGiftingCart: (data: any) => void;
  shopCurrency: string;
  giftId: string;
  cartLoading: boolean;
  setCartLoading: (loading: boolean) => void;
  giftingCategory: {
    [index: number]: string;
  }[];
  giftParams: string;
}
interface PersonalMessage {
  productData: GiftingProduct[][];
  onNext: (giftId: string) => void;
  onBack: () => void;
  onGiftChange: (
    variantId: number,
    productId: number | undefined,
    type: GiftType,
    index: number,
  ) => void;
  giftingCart: CartGifting;
  setGiftingCart: (data: any) => void;
  onChangeRecipientName: (recipientName: string) => void;
  onChangeMessage: (message: string) => void;
  giftId: string;
  cartLoading: boolean;
  setCartLoading: (loading: boolean) => void;
  giftingCategory: {
    [index: number]: string;
  }[];
}

interface AddonBoxWrapping {
  productData: GiftingProduct[][];
  onNext: (giftId: string) => void;
  onBack: () => void;
  onGiftChange: (
    variantId: number,
    productId: number | undefined,
    type: GiftType,
    index: number,
  ) => void;
  giftingCart: CartGifting;
  setGiftingCart: (data: any) => void;
  giftId: string;
  cartLoading: boolean;
  setCartLoading: (loading: boolean) => void;
  giftingCategory: {
    [index: number]: string;
  }[];
}

interface ReviewGiftBoxProps {
  productData: GiftingProduct[][];
  onBack: () => void;
  onGiftChange: (
    variantId: number,
    productId: number | undefined,
    type: GiftType,
    index: number,
  ) => void;
  giftingCart: CartGifting;
  onHandleGiftingCart: () => void;
  totalPrice: number;
  minSpend: number;
  discountAmount: number;
  discountType: string;
  productTitle: string;
  setPopupData: (popupData: any) => void;
  popupData: any;
  cartLoading: boolean;
  setCartLoading: (loading: boolean) => void;
  giftingCategory: {
    [index: number]: string;
  }[];
  setCurrentPage: (page: number) => void;
}
interface GiftingCategory {
  [index: number]: string;
}

const ChooseProductPage: React.FC<ChooseProductProps> = ({
  productData,
  totalPrice,
  onBack,
  onNextStep,
  onGiftChange,
  productColourSwatches,
  giftingCart,
  setGiftingCart,
  shopCurrency,
  giftId,
  cartLoading,
  setCartLoading,
  giftingCategory,
  giftParams,
}) => {
  const [mainGift, setMainGift] = useState<GiftingProduct[]>([]);
  const [disabled, setDisabled] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState<{ [index: number]: SelectedOption }>({});
  const [selectedComboProducts, setSelectedComboProducts] = useState<
    { variantId: number; productId: number | undefined }[]
  >([]);
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const disclosureRefs = useRef<Array<HTMLElement | null>>([]);
  const shopCurrencyValue = shopCurrency;
  const isVariantOutOfStock = (variant: VariantsEntity) => {
    return variant.inventory_quantity === 0 && variant.inventory_policy === 'deny';
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState<{
    product: GiftingProduct;
    index: number;
    type: GiftType;
    productIndex: number;
    shopCurrencyValue: string;
  } | null>(null);
  const [allgifts, setAllGift] = useState<any[]>([]);
  const [alertMessage, setAlertMessage] = useState<string | null>(null);

  useEffect(() => {
    const allGifts = [
      ...(giftingCart.mainGift ? giftingCart.mainGift.filter((item) => item != null) : []),
      ...(giftingCart.accessoriesGift
        ? giftingCart.accessoriesGift.filter((item) => item != null)
        : []),
    ];
    setAllGift(allGifts);
  }, [giftingCart]);

  useEffect(() => {
    // set selected combo products based on selected options
    const selectedComboProducts: { variantId: number; productId: number }[] = new Array( // set array of selectedCombo Product based on product length
      productData.length,
    ).fill(null);
    setCartLoading(true);
    productData?.forEach((product, productIndex) => {
      product.map((p) => {
        if (p.id === selectedProduct?.product.id) {
          // select first variant if there's just one option
          if (
            selectedProduct?.product.variants?.length === 1 &&
            !isVariantOutOfStock(selectedProduct?.product?.variants?.[0] as any)
          ) {
            selectedComboProducts[productIndex] = selectedComboProducts[productIndex];
            return;
          }

          const selectedOption = selectedOptions[productIndex];
          const selectedVariants =
            (selectedOption &&
              selectedProduct?.product.variants?.filter((variant) => {
                return Object.keys(selectedOption).every((key) => {
                  return selectedOption[key as OptionKeys] === variant[key as OptionKeys];
                });
              })) ||
            [];
          if (selectedVariants.length === 1 && !isVariantOutOfStock(selectedVariants[0] as any)) {
            selectedComboProducts[productIndex] = {
              variantId: selectedVariants[0].id,
              productId: selectedProduct?.product.id,
            };
          }
        }
      });
    });

    setSelectedComboProducts(selectedComboProducts);
  }, [selectedOptions, setSelectedComboProducts, selectedProduct]);
  const isInProductData = (
    product: GiftingProduct,
    type: GiftType,
    productIndex: number,
    giftingIndex: number,
  ) => {
    setCartLoading(false);
    let found = false;
    giftingCart?.[type]?.map((e, i) => {
      if (e?.productId === product.id) {
        found = true;
      }
    });
    return found;
  };
  const addToBoxText = (
    product: GiftingProduct,
    index: number,
    type: GiftType,
    giftingIndex: number,
  ) => {
    return isInProductData(product, type, index, giftingIndex) ? 'Added to Box' : 'Add to Box';
  };
  const addToBoxStyle = (
    product: GiftingProduct,
    productIndex: number, // product in gifting row
    type: GiftType,
    giftingIndex: number, // gifting eg, 1 - main, 2 - accessories.. etc
  ) => {
    return isInProductData(product, type, productIndex, giftingIndex)
      ? { backgroundColor: '#6f1920', color: 'white' }
      : { border: '1.5px solid black', color: 'black', marginTop: '30px' };
  };
  const addToBox = (type: GiftType, p: GiftingProduct, index: number) => {
    if (type === 'mainGift') {
      if (p.variants?.length === 1 && !isVariantOutOfStock(p?.variants?.[0] as any)) {
        onGiftChange(p.variants[0].id, p.variants[0].product_id, type, index);
      } else if (p.variants?.length !== 1) {
        if (selectedComboProducts[index] === null) {
          setAlertMessage('Please select the variant');
          return;
        }
        onGiftChange(
          selectedComboProducts[index].variantId,
          selectedComboProducts[index].productId,
          type,
          index,
        );
      }
    } else if (type === 'accessoriesGift') {
      if (p.variants?.length === 1 && !isVariantOutOfStock(p?.variants?.[0] as any)) {
        onGiftChange(p.variants[0].id, p.variants[0].product_id, type, index);
      } else if (p.variants?.length !== 1) {
        if (selectedComboProducts[index] === null) {
          setAlertMessage('Please select the variant accessories');
          return;
        }
        onGiftChange(
          selectedComboProducts[index].variantId,
          selectedComboProducts[index].productId,
          type,
          index,
        );
      }
    } else if (type === 'wishCardGift') {
      onGiftChange(
        selectedComboProducts[2].variantId,
        selectedComboProducts[2].productId,
        type,
        index,
      );
    } else if (type === 'boxGift') {
      onGiftChange(
        selectedComboProducts[3].variantId,
        selectedComboProducts[3].productId,
        type,
        index,
      );
    } else if (type === 'wrappingGift') {
      onGiftChange(
        selectedComboProducts[4].variantId,
        selectedComboProducts[4].productId,
        type,
        index,
      );
    }

    handleCloseModal();
    setSelectedOptions({});
    setAlertMessage(null);

    if (disclosureRefs.current[index]) {
      const currentDisclosure = disclosureRefs.current[index];
      const button = currentDisclosure.querySelector('button');
      if (button) {
        button.click();
      }
    }

    // Open the next accordion
    const nextIndex = index + 1;
    if (nextIndex < productData.length && disclosureRefs.current[nextIndex]) {
      setTimeout(() => {
        const nextDisclosure = disclosureRefs.current[nextIndex];
        if (nextDisclosure) {
          const button = nextDisclosure.querySelector('button');
          if (button) {
            button.click();
          }
        }
        setOpenIndex(nextIndex);
      }, 0);
    } else {
      setOpenIndex(null);
    }
  };

  const handleSelectOption = (
    productIndex: number,
    index: number,
    optionName: OptionKeys,
    optionValue: string,
  ) => {
    // check if already checked
    setAlertMessage(null);
    const selectedOption = selectedOptions[productIndex];
    if (selectedOption && selectedOption[optionName] === optionValue) {
      setSelectedOptions((prev) => {
        const selectedOption = { ...prev[productIndex] };
        delete selectedOption[optionName];
        return {
          ...prev,
          [productIndex]: selectedOption,
        };
      });
      return;
    } else {
      setSelectedOptions((prev) => ({
        ...prev,
        [productIndex]: {
          ...prev[productIndex],
          [optionName]: optionValue,
        },
      }));
    }
  };
  const swatchMap = productColourSwatches.reduce((acc, curr) => {
    const [key, value] = curr.split(':').map((str) => str.trim());
    acc[key] = value;
    return acc;
  }, {} as { [key: string]: string });

  const handleOpenModal = (
    product: GiftingProduct,
    index: number,
    type: GiftType,
    productIndex: number,
    shopCurrencyValue: string,
  ) => {
    setSelectedProduct({
      product: product,
      index: index,
      type: type,
      productIndex: productIndex,
      shopCurrencyValue: shopCurrencyValue,
    });
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedProduct(null);
    setSelectedOptions({});
    setAlertMessage(null);
  };

  const handleRemoveProduct = (index: number, type: GiftType) => {
    if (type === 'mainGift' || type === 'accessoriesGift') {
      const newData = giftingCart?.[type] ? [...giftingCart[type]] : [];
      if (newData?.[index] !== undefined) {
        newData[index] = {} as any;
      }
      const newGiftingCart = giftingCart?.[type]?.splice(index, 1);
      setGiftingCart((prev: any) => ({
        ...prev,
        [type]: null,
      }));
    } else {
      const newData = giftingCart?.[type] ? [...giftingCart[type]] : [];
      if (newData?.[index] !== undefined) {
        newData[index] = {};
      }
      const newGiftingCart = giftingCart?.[type]?.splice(index, 1);
      setGiftingCart((prev: any) => ({
        ...prev,
        [type]: null,
      }));
    }
  };
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  console.log({ productData });
  return (
    <div className="container">
      <div className="box-button-container">
        <button
          onClick={() =>
            giftParams
              ? (window.location.href = 'https://sitikhadijah.com/pages/ramadan-gifting ')
              : onBack
          }
        >
          {/* <button onClick={onBack}> */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            style={{ width: '20px' }}
          >
            <path
              fill-rule="evenodd"
              d="M11.78 5.22a.75.75 0 0 1 0 1.06L8.06 10l3.72 3.72a.75.75 0 1 1-1.06 1.06l-4.25-4.25a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z"
              clip-rule="evenodd"
            />
          </svg>
          Choose Gift Set
        </button>
        {allgifts.length ===
        [
          ...giftingCategory.filter((e) => e === 'mainProduct'),
          ...giftingCategory.filter((e) => e === 'accessoriesProduct'),
        ].length ? (
          <button onClick={() => onNextStep(giftId)}>
            Select Box and Wrapping
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              style={{ width: '20px' }}
            >
              <path
                fill-rule="evenodd"
                d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
        ) : null}
      </div>
      {cartLoading && <div id="cover-spin"></div>}
      <div className="gifting-selected-product-container">
        <div className="gifting-pick">
          <h1>Pick What's Inside</h1>
          <p>
            Add up to{' '}
            {
              [
                ...giftingCategory.filter((e) => e === 'mainProduct'),
                ...giftingCategory.filter((e) => e === 'accessoriesProduct'),
              ].length
            }{' '}
            items to your gift box.
          </p>
          <div className="flex justify-between">
            {giftingCart?.mainGift !== undefined && giftingCart?.mainGift?.length > 0 ? (
              giftingCart.mainGift?.map((mainGift, index) => {
                const maingift = giftingCart.mainGift?.[index];

                let productMainGift = {} as GiftingProduct;
                productData?.map((product) => {
                  product.map((p) => {
                    if (p.id === maingift?.productId) {
                      productMainGift = p;
                    }
                  });
                });
                let mainProductImage = {} as any;
                mainProductImage = productMainGift?.images?.find((image) =>
                  image.variant_ids?.find((variant) => variant === maingift?.variantId),
                );
                if (mainProductImage === undefined) {
                  mainProductImage = productMainGift.image;
                }
                let placeholderUrls = [] as string[];
                if (giftParams === '8480706199740') {
                  placeholderUrls = [
                    'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/3_388fb02d-8c3b-4e37-96a2-ed4a002c0ac5.png?v=1715706346',
                  ];
                } else if (giftParams === '8480656228540') {
                  placeholderUrls = [
                    'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/2_685be79b-3fd7-4c5e-9f58-7ce9a6db1b4f.png?v=1715706345',
                  ];
                } else if (giftParams === '8480586399932') {
                  placeholderUrls = [
                    'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/1_8652a78a-7268-4964-a090-b5cc8894e4a7.png?v=1715706345',
                    'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/4_bea88dc1-f447-4627-90d2-b65b36d91aa6.png?v=1715706345',
                  ];
                }
                return (
                  <div className="gifting-image-container">
                    {mainProductImage?.src !== undefined ? (
                      <div
                        className="image-wrapper"
                        onClick={() => handleRemoveProduct(index, 'mainGift')}
                      >
                        <img
                          src={
                            mainProductImage?.src
                              ? mainProductImage?.src
                              : productMainGift?.image.src
                          }
                          alt={
                            mainProductImage?.src
                              ? mainProductImage?.src
                              : productMainGift?.image.src
                          }
                          className="gift-image"
                        />
                        <div className="remove-overlay">REMOVE</div>
                      </div>
                    ) : (
                      <>
                        <img src={placeholderUrls[0]} alt="Placeholder" className="gift-image" />
                      </>
                    )}
                  </div>
                );
              })
            ) : (
              <>
                {giftingCategory
                  .filter((gc) => gc === 'mainProduct')
                  .map((mainProduct, i) => {
                    let placeholderUrls = [] as string[];
                    if (giftParams === '8480706199740') {
                      placeholderUrls = [
                        'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/3_388fb02d-8c3b-4e37-96a2-ed4a002c0ac5.png?v=1715706346',
                      ];
                    } else if (giftParams === '8480656228540') {
                      placeholderUrls = [
                        'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/2_685be79b-3fd7-4c5e-9f58-7ce9a6db1b4f.png?v=1715706345',
                      ];
                    } else if (giftParams === '8480586399932') {
                      placeholderUrls = [
                        'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/1_8652a78a-7268-4964-a090-b5cc8894e4a7.png?v=1715706345',
                        'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/4_bea88dc1-f447-4627-90d2-b65b36d91aa6.png?v=1715706345',
                      ];
                    }
                    return (
                      <div className="gifting-image-container">
                        <img src={placeholderUrls[0]} alt="Placeholder" className="gift-image" />
                      </div>
                    );
                  })}
              </>
            )}
            {giftingCart?.accessoriesGift !== undefined && giftingCart?.accessoriesGift?.length > 0
              ? giftingCart?.accessoriesGift?.map((product, index, array) => {
                  const accessoriesGift = giftingCart.accessoriesGift?.[index];

                  let productAccessories = {} as GiftingProduct;
                  productData?.map((product) => {
                    product.map((p) => {
                      if (p.id === accessoriesGift?.productId) {
                        productAccessories = p;
                      }
                    });
                  });
                  let accessoriesProductImage = {} as any;
                  accessoriesProductImage = productAccessories?.images?.find((image) =>
                    image.variant_ids?.find((variant) => variant === accessoriesGift?.variantId),
                  );
                  if (accessoriesProductImage === undefined) {
                    accessoriesProductImage = productAccessories.image;
                  }

                  let placeholderUrls = [] as string[];
                  if (giftParams === '8480706199740') {
                    placeholderUrls = [
                      'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/3_388fb02d-8c3b-4e37-96a2-ed4a002c0ac5.png?v=1715706346',
                    ];
                  } else if (giftParams === '8480656228540') {
                    placeholderUrls = [
                      'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/2_685be79b-3fd7-4c5e-9f58-7ce9a6db1b4f.png?v=1715706345',
                    ];
                  } else if (giftParams === '8480586399932') {
                    placeholderUrls = [
                      'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/1_8652a78a-7268-4964-a090-b5cc8894e4a7.png?v=1715706345',
                      'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/4_bea88dc1-f447-4627-90d2-b65b36d91aa6.png?v=1715706345',
                    ];
                  }
                  return (
                    <div className="gifting-image-container">
                      {accessoriesProductImage?.src ? (
                        <div
                          className="image-wrapper"
                          onClick={() => handleRemoveProduct(index, 'accessoriesGift')}
                        >
                          <img
                            src={
                              accessoriesProductImage?.src
                                ? accessoriesProductImage?.src
                                : productAccessories?.image.src
                            }
                            alt={
                              accessoriesProductImage?.src
                                ? accessoriesProductImage?.src
                                : productAccessories?.image.src
                            }
                            className="gift-image"
                          />
                          <div className="remove-overlay">REMOVE</div>
                        </div>
                      ) : (
                        <img
                          src={placeholderUrls[index]}
                          alt="Placeholder"
                          className="gift-image"
                        />
                      )}
                    </div>
                  );
                })
              : (giftingCart?.accessoriesGift as any)?.length < 0
              ? giftingCart?.accessoriesGift?.map((product, index) => {
                  let placeholderUrls = [] as string[];
                  if (giftParams === '8480706199740') {
                    placeholderUrls = [
                      'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/3_388fb02d-8c3b-4e37-96a2-ed4a002c0ac5.png?v=1715706346',
                    ];
                  } else if (giftParams === '8480656228540') {
                    placeholderUrls = [
                      'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/2_685be79b-3fd7-4c5e-9f58-7ce9a6db1b4f.png?v=1715706345',
                    ];
                  } else if (giftParams === '8480586399932') {
                    placeholderUrls = [
                      'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/1_8652a78a-7268-4964-a090-b5cc8894e4a7.png?v=1715706345',
                      'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/4_bea88dc1-f447-4627-90d2-b65b36d91aa6.png?v=1715706345',
                    ];
                  }
                  return (
                    <div key={index} className="gifting-image-container">
                      <img src={placeholderUrls[index]} alt="Placeholder" className="gift-image" />
                    </div>
                  );
                })
              : giftingCategory
                  .filter((gc) => gc === 'accessoriesProduct')
                  .map((accessoriesProduct, index) => {
                    let placeholderUrls = [] as string[];
                    if (giftParams === '8480706199740') {
                      placeholderUrls = [
                        'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/3_388fb02d-8c3b-4e37-96a2-ed4a002c0ac5.png?v=1715706346',
                      ];
                    } else if (giftParams === '8480656228540') {
                      placeholderUrls = [
                        'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/2_685be79b-3fd7-4c5e-9f58-7ce9a6db1b4f.png?v=1715706345',
                      ];
                    } else if (giftParams === '8480586399932') {
                      placeholderUrls = [
                        'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/1_8652a78a-7268-4964-a090-b5cc8894e4a7.png?v=1715706345',
                        'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/4_bea88dc1-f447-4627-90d2-b65b36d91aa6.png?v=1715706345',
                      ];
                    }
                    return (
                      <div key={index} className="gifting-image-container">
                        <img
                          src={placeholderUrls[index]}
                          alt="Placeholder"
                          className="gift-image"
                        />
                      </div>
                    );
                  })}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              style={{ width: '20px' }}
            >
              <path d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z" />
            </svg>

            {giftingCart?.boxGift !== undefined && giftingCart?.boxGift?.length > 0 ? (
              giftingCart.boxGift?.map((boxGift, index) => {
                let boxProduct = null;
                if (productData) {
                  for (const productArray of productData) {
                    boxProduct = productArray.find((product) => product.id === boxGift.productId);
                    if (boxProduct) {
                      break;
                    }
                  }
                }

                return (
                  <div
                    className="image-wrapper"
                    onClick={() => handleRemoveProduct(index, 'boxGift')}
                  >
                    <div className="gifting-image-container">
                      <img src={boxProduct?.image?.src} alt="Placeholder" className="gift-image" />
                    </div>
                    <div className="remove-overlay">REMOVE</div>
                  </div>
                );
              })
            ) : (
              <div className="gifting-image-container">
                <img
                  src="https://cdn.shopify.com/s/files/1/0605/5100/4348/files/7.png?v=1716438789"
                  alt="Placeholder"
                  className="gift-image"
                />
              </div>
            )}

            {giftingCart?.wrappingGift !== undefined && giftingCart?.wrappingGift?.length > 0 ? (
              giftingCart.wrappingGift?.map((wrappingGift, index) => {
                let wrappingProduct = null;
                let wrappingImage = null;

                // Find the wrapping product
                for (const productArray of productData) {
                  wrappingProduct = productArray.find((product) =>
                    product.variants?.some((variant) => variant.id === wrappingGift.variantId),
                  );

                  if (wrappingProduct) {
                    wrappingProduct = wrappingProduct?.variants?.find(
                      (variant) => variant.id === wrappingGift.variantId,
                    );
                    break;
                  }
                }

                // Find the wrapping image
                if (wrappingProduct) {
                  for (const productArray of productData) {
                    for (const product of productArray) {
                      wrappingImage = product.images?.find(
                        (image) => image.id === wrappingProduct.image_id,
                      );
                      if (wrappingImage) {
                        break;
                      }
                    }
                    if (wrappingImage) {
                      break;
                    }
                  }
                }

                return (
                  <div
                    className="image-wrapper"
                    onClick={() => handleRemoveProduct(index, 'wrappingGift')}
                  >
                    <div key={wrappingProduct?.id} className="gifting-image-container">
                      <img
                        src={wrappingImage?.src}
                        alt={wrappingProduct?.title}
                        className="gift-image"
                      />
                    </div>
                    <div className="remove-overlay">REMOVE</div>
                  </div>
                );
              })
            ) : (
              <div className="gifting-image-container">
                <img
                  src="https://cdn.shopify.com/s/files/1/0605/5100/4348/files/6.png?v=1716438788"
                  alt="Placeholder"
                  className="gift-image"
                />
              </div>
            )}

            {giftingCart?.wishCardGift !== undefined && giftingCart?.wishCardGift?.length > 0 ? (
              giftingCart.wishCardGift?.map((wishCardGift, index) => {
                let wishcardProductImage = null;

                // Check if variantId exists and is a number
                const variantId = wishCardGift.variantId;

                if (variantId !== undefined) {
                  // Iterate through productData to find the matching image
                  if (productData) {
                    for (const productArray of productData) {
                      for (const product of productArray) {
                        wishcardProductImage = product.images?.find((image) =>
                          image.variant_ids?.includes(variantId as any),
                        );
                        if (wishcardProductImage) {
                          break;
                        }
                      }
                      if (wishcardProductImage) {
                        break;
                      }
                    }
                  }
                }
                return (
                  <div
                    className="image-wrapper"
                    onClick={() => handleRemoveProduct(index, 'wishCardGift')}
                  >
                    <div key={wishcardProductImage?.id} className="gifting-image-container">
                      <img src={wishcardProductImage?.src} className="gift-image" />
                    </div>
                    <div className="remove-overlay">REMOVE</div>
                  </div>
                );
              })
            ) : (
              <div className="gifting-image-container">
                <img
                  src="https://cdn.shopify.com/s/files/1/0605/5100/4348/files/5.png?v=1716438788"
                  alt="Placeholder"
                  className="gift-image"
                />
              </div>
            )}
          </div>
        </div>
        <div className="gifting-box-content flex flex-col justify-between">
          <div>
            <h4 style={{ padding: '0 0 0 0.7rem' }}>Box Contents</h4>
            <table className="gifting-box-content-table">
              <tbody>
                {giftingCart?.mainGift !== undefined && giftingCart?.mainGift?.length > 0 ? (
                  <p style={{ padding: '0.7rem 0px 0px 0.7rem', fontWeight: 'bold' }}>Products</p>
                ) : null}

                {giftingCart?.mainGift !== undefined && giftingCart?.mainGift?.length > 0
                  ? giftingCart.mainGift?.map((mainGift, index) => {
                      const maingift = giftingCart.mainGift?.[index];

                      let mainProduct = {} as GiftingProduct;
                      productData?.map((product) => {
                        product.map((p) => {
                          if (p.id === maingift?.productId) {
                            mainProduct = p;
                          }
                        });
                      });
                      let mainProductImage = {} as any;
                      mainProductImage = mainProduct?.images?.find((image) =>
                        image.variant_ids?.find((variant) => variant === maingift?.variantId),
                      );
                      if (mainProductImage === undefined) {
                        mainProductImage = mainProduct.image;
                      }
                      return (
                        <tr>
                          <td>{mainProduct?.title}</td>
                          <td className="remove-icon">
                            {mainProduct?.variants?.[0]?.price !== undefined
                              ? `RM ${mainProduct?.variants?.[0]?.price}`
                              : null}{' '}
                          </td>
                          <td className="remove-icon">
                            {mainProduct?.variants?.[0]?.price !== undefined ? (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth="1.5"
                                stroke="currentColor"
                                style={{ width: '20px' }}
                                onClick={() => handleRemoveProduct(index, 'mainGift')}
                                className="svg-hover"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M6 18 18 6M6 6l12 12"
                                />
                              </svg>
                            ) : null}
                          </td>
                        </tr>
                      );
                    })
                  : null}
                {giftingCart?.accessoriesGift !== undefined &&
                giftingCart?.accessoriesGift?.length > 0
                  ? giftingCart.accessoriesGift?.map((accessoriesGift, index) => {
                      let accessoriesProduct = {} as GiftingProduct;
                      const productInfo = productData?.map((productinfo, index) => {
                        productinfo.map((p, i) => {
                          if (p.id === accessoriesGift?.productId) {
                            accessoriesProduct = p;
                          }
                        });
                      });
                      return (
                        <tr>
                          <td>{accessoriesProduct?.title}</td>
                          <td className="remove-icon">
                            {accessoriesProduct?.variants?.[0]?.price !== undefined
                              ? `RM ${accessoriesProduct?.variants?.[0]?.price}`
                              : null}
                          </td>
                          <td className="remove-icon">
                            {accessoriesProduct?.variants?.[0]?.price !== undefined ? (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth="1.5"
                                stroke="currentColor"
                                style={{ width: '20px' }}
                                onClick={() => handleRemoveProduct(index, 'accessoriesGift')}
                                className="svg-hover"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M6 18 18 6M6 6l12 12"
                                />
                              </svg>
                            ) : null}
                          </td>
                        </tr>
                      );
                    })
                  : null}

                {giftingCart?.wrappingGift !== undefined ? (
                  <p style={{ padding: '0.7rem 0px 0px 0.7rem', fontWeight: 'bold' }}>
                    Gift box, wrapping and wish card.
                  </p>
                ) : null}

                {giftingCart?.wrappingGift !== undefined && giftingCart?.wrappingGift?.length > 0
                  ? giftingCart.wrappingGift?.map((wrappingGift, index) => {
                      let wrappingProduct = null;

                      // Find the wrapping product
                      for (const productArray of productData) {
                        wrappingProduct = productArray.find((product) =>
                          product.variants?.some(
                            (variant) => variant.id === wrappingGift.variantId,
                          ),
                        );

                        if (wrappingProduct) {
                          wrappingProduct = wrappingProduct?.variants?.find(
                            (variant) => variant.id === wrappingGift.variantId,
                          );
                          break;
                        }
                      }
                      return (
                        // <hr />
                        <tr>
                          <td>{wrappingProduct?.title}</td>
                          <td className="remove-icon">
                            {wrappingProduct?.price !== undefined
                              ? `RM ${wrappingProduct?.price}`
                              : null}
                          </td>
                          <td className="remove-icon">
                            {wrappingProduct?.price !== undefined ? (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth="1.5"
                                stroke="currentColor"
                                style={{ width: '20px' }}
                                onClick={() => handleRemoveProduct(index, 'accessoriesGift')}
                                className="svg-hover"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M6 18 18 6M6 6l12 12"
                                />
                              </svg>
                            ) : null}
                          </td>
                        </tr>
                      );
                    })
                  : null}
                {giftingCart?.boxGift !== undefined && giftingCart?.boxGift?.length > 0
                  ? giftingCart.boxGift?.map((boxGift, index) => {
                      let boxProduct = null;
                      if (productData) {
                        for (const productArray of productData) {
                          boxProduct = productArray.find(
                            (product) => product.id === boxGift.productId,
                          );
                          if (boxProduct) {
                            break;
                          }
                        }
                      }
                      return (
                        // <hr />
                        // <p>Gift box, wrapping and wish card.</p>
                        <tr>
                          <td>{boxProduct?.title}</td>
                          <td className="remove-icon">
                            {boxProduct?.variants?.[0]?.price !== undefined
                              ? `RM ${boxProduct?.variants?.[0]?.price}`
                              : null}
                          </td>
                          <td className="remove-icon">
                            {boxProduct?.variants?.[0]?.price !== undefined ? (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth="1.5"
                                stroke="currentColor"
                                style={{ width: '20px' }}
                                onClick={() => handleRemoveProduct(index, 'accessoriesGift')}
                                className="svg-hover"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M6 18 18 6M6 6l12 12"
                                />
                              </svg>
                            ) : null}
                          </td>
                        </tr>
                      );
                    })
                  : null}
                {giftingCart?.wishCardGift !== undefined && giftingCart?.wishCardGift?.length > 0
                  ? giftingCart.wishCardGift?.map((wishCardGift, index) => {
                      let wishCardProduct = null;

                      // Find the wrapping product
                      for (const productArray of productData) {
                        wishCardProduct = productArray.find((product) =>
                          product.variants?.some(
                            (variant) => variant.id === wishCardGift.variantId,
                          ),
                        );

                        if (wishCardProduct) {
                          wishCardProduct = wishCardProduct?.variants?.find(
                            (variant) => variant.id === wishCardGift.variantId,
                          );
                          break;
                        }
                      }
                      return (
                        // <hr />
                        // <p>Gift box, wrapping and wish card.</p>
                        <tr>
                          <td>{wishCardProduct?.title}</td>
                          <td className="remove-icon">
                            {wishCardProduct?.price !== undefined
                              ? `RM ${wishCardProduct?.price}`
                              : null}
                          </td>
                          <td className="remove-icon">
                            {wishCardProduct?.price !== undefined ? (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth="1.5"
                                stroke="currentColor"
                                style={{ width: '20px' }}
                                onClick={() => handleRemoveProduct(index, 'accessoriesGift')}
                                className="svg-hover"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M6 18 18 6M6 6l12 12"
                                />
                              </svg>
                            ) : null}
                          </td>
                        </tr>
                      );
                    })
                  : null}
              </tbody>
            </table>
            <hr />
            <h4 className="gifting-subtotal-product-price">Subtotal: RM {totalPrice.toFixed(2)}</h4>
          </div>
        </div>
      </div>
      <div className="mobile-selected-products-container active flex justify-between">
        <div className="gifting-image-bottom-container">
          {giftingCart?.mainGift !== undefined && giftingCart?.mainGift?.length > 0 ? (
            giftingCart.mainGift?.map((mainGift, index) => {
              const maingift = giftingCart.mainGift?.[index];

              let productMainGift = {} as GiftingProduct;
              productData?.map((product) => {
                product.map((p) => {
                  if (p.id === maingift?.productId) {
                    productMainGift = p;
                  }
                });
              });
              let mainProductImage = {} as any;
              mainProductImage = productMainGift?.images?.find((image) =>
                image.variant_ids?.find((variant) => variant === maingift?.variantId),
              );
              if (mainProductImage === undefined) {
                mainProductImage = productMainGift.image;
              }

              let placeholderUrls = [] as string[];
              if (giftParams === '8480706199740') {
                placeholderUrls = [
                  'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/3_388fb02d-8c3b-4e37-96a2-ed4a002c0ac5.png?v=1715706346',
                ];
              } else if (giftParams === '8480656228540') {
                placeholderUrls = [
                  'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/2_685be79b-3fd7-4c5e-9f58-7ce9a6db1b4f.png?v=1715706345',
                ];
              } else if (giftParams === '8480586399932') {
                placeholderUrls = [
                  'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/1_8652a78a-7268-4964-a090-b5cc8894e4a7.png?v=1715706345',
                  'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/4_bea88dc1-f447-4627-90d2-b65b36d91aa6.png?v=1715706345',
                ];
              }

              return (
                <div className="gifting-image-container-summary">
                  {mainProductImage?.src ? (
                    <div
                      className="image-wrapper"
                      onClick={() => handleRemoveProduct(index, 'mainGift')}
                    >
                      <img
                        src={
                          mainProductImage?.src ? mainProductImage?.src : productMainGift?.image.src
                        }
                        alt={
                          mainProductImage?.src ? mainProductImage?.src : productMainGift?.image.src
                        }
                        className="gift-image-bottom-summary gift-image-in-summary-container"
                      />
                      <div className="remove-overlay">REMOVE</div>
                    </div>
                  ) : (
                    <img
                      src={placeholderUrls[0]}
                      alt="Placeholder"
                      className="gift-image-bottom-summary gift-image-in-summary-container"
                    />
                  )}
                </div>
              );
            })
          ) : (
            <>
              {giftingCategory
                .filter((gc) => gc === 'mainProduct')
                .map((mainProduct, i) => {
                  let placeholderUrls = [] as string[];
                  if (giftParams === '8480706199740') {
                    placeholderUrls = [
                      'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/3_388fb02d-8c3b-4e37-96a2-ed4a002c0ac5.png?v=1715706346',
                    ];
                  } else if (giftParams === '8480656228540') {
                    placeholderUrls = [
                      'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/2_685be79b-3fd7-4c5e-9f58-7ce9a6db1b4f.png?v=1715706345',
                    ];
                  } else if (giftParams === '8480586399932') {
                    placeholderUrls = [
                      'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/1_8652a78a-7268-4964-a090-b5cc8894e4a7.png?v=1715706345',
                      'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/4_bea88dc1-f447-4627-90d2-b65b36d91aa6.png?v=1715706345',
                    ];
                  }
                  return (
                    <div className="gifting-image-container-summary">
                      <img
                        src={placeholderUrls[0]}
                        alt="Placeholder"
                        className="gift-image-bottom-summary gift-image-in-summary-container"
                      />
                    </div>
                  );
                })}
            </>
          )}
          {giftingCart?.accessoriesGift !== undefined && giftingCart?.accessoriesGift?.length > 0
            ? giftingCart?.accessoriesGift?.map((product, index, array) => {
                const accessoriesGift = giftingCart.accessoriesGift?.[index];

                let productAccessories = {} as GiftingProduct;
                productData?.map((product) => {
                  product.map((p) => {
                    if (p.id === accessoriesGift?.productId) {
                      productAccessories = p;
                    }
                  });
                });
                let accessoriesProductImage = {} as any;
                accessoriesProductImage = productAccessories?.images?.find((image) =>
                  image.variant_ids?.find((variant) => variant === accessoriesGift?.variantId),
                );
                if (accessoriesProductImage === undefined) {
                  accessoriesProductImage = productAccessories.image;
                }

                let placeholderUrls = [] as string[];
                if (giftParams === '8480706199740') {
                  placeholderUrls = [
                    'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/3_388fb02d-8c3b-4e37-96a2-ed4a002c0ac5.png?v=1715706346',
                  ];
                } else if (giftParams === '8480656228540') {
                  placeholderUrls = [
                    'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/2_685be79b-3fd7-4c5e-9f58-7ce9a6db1b4f.png?v=1715706345',
                  ];
                } else if (giftParams === '8480586399932') {
                  placeholderUrls = [
                    'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/1_8652a78a-7268-4964-a090-b5cc8894e4a7.png?v=1715706345',
                    'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/4_bea88dc1-f447-4627-90d2-b65b36d91aa6.png?v=1715706345',
                  ];
                }

                return (
                  <div key={index} className="gifting-image-container-summary">
                    {accessoriesProductImage?.src ? (
                      <div
                        className="image-wrapper"
                        onClick={() => handleRemoveProduct(index, 'accessoriesGift')}
                      >
                        <img
                          src={
                            accessoriesProductImage?.src
                              ? accessoriesProductImage?.src
                              : productAccessories?.image.src
                          }
                          alt={
                            accessoriesProductImage?.src
                              ? accessoriesProductImage?.src
                              : productAccessories?.image.src
                          }
                          className="gift-image-bottom-summary gift-image-in-summary-container"
                        />
                        <div className="remove-overlay">REMOVE</div>
                      </div>
                    ) : (
                      <img
                        src={placeholderUrls[index]}
                        alt="Placeholder"
                        className="gift-image-bottom-summary gift-image-in-summary-container"
                      />
                    )}
                  </div>
                );
              })
            : giftingCategory
                .filter((gc) => gc === 'accessoriesProduct')
                .map((accessoriesProduct, index) => {
                  let placeholderUrls = [] as string[];
                  if (giftParams === '8480706199740') {
                    placeholderUrls = [
                      'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/3_388fb02d-8c3b-4e37-96a2-ed4a002c0ac5.png?v=1715706346',
                    ];
                  } else if (giftParams === '8480656228540') {
                    placeholderUrls = [
                      'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/2_685be79b-3fd7-4c5e-9f58-7ce9a6db1b4f.png?v=1715706345',
                    ];
                  } else if (giftParams === '8480586399932') {
                    placeholderUrls = [
                      'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/1_8652a78a-7268-4964-a090-b5cc8894e4a7.png?v=1715706345',
                      'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/4_bea88dc1-f447-4627-90d2-b65b36d91aa6.png?v=1715706345',
                    ];
                  }
                  return (
                    <div key={index} className="gifting-image-container-summary">
                      <img
                        src={placeholderUrls[index]}
                        alt="Placeholder"
                        className="gift-image-bottom-summary gift-image-in-summary-container"
                      />
                    </div>
                  );
                })}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            style={{ width: '12px' }}
          >
            <path d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z" />
          </svg>

          {giftingCart?.boxGift !== undefined && giftingCart?.boxGift?.length > 0 ? (
            giftingCart.boxGift?.map((boxGift, index) => {
              let boxProduct = null;
              if (productData) {
                for (const productArray of productData) {
                  boxProduct = productArray.find((product) => product.id === boxGift.productId);
                  if (boxProduct) {
                    break;
                  }
                }
              }

              return (
                <div
                  className="image-wrapper"
                  onClick={() => handleRemoveProduct(index, 'boxGift')}
                >
                  <div className="gifting-image-container-summary">
                    <img
                      src={boxProduct?.image?.src}
                      alt="Placeholder"
                      className="gift-image-bottom-summary gift-image-in-summary-container"
                    />
                  </div>
                  <div className="remove-overlay">REMOVE</div>
                </div>
              );
            })
          ) : (
            <div className="gifting-image-container-summary">
              <img
                src="https://cdn.shopify.com/s/files/1/0605/5100/4348/files/7.png?v=1716438789"
                alt="Placeholder"
                className="gift-image-bottom-summary gift-image-in-summary-container"
              />
            </div>
          )}
          {giftingCart?.wrappingGift !== undefined && giftingCart?.wrappingGift?.length > 0 ? (
            giftingCart.wrappingGift?.map((wrappingGift, index) => {
              let wrappingProduct = null;
              let wrappingImage = null;

              // Find the wrapping product
              for (const productArray of productData) {
                wrappingProduct = productArray.find((product) =>
                  product.variants?.some((variant) => variant.id === wrappingGift.variantId),
                );

                if (wrappingProduct) {
                  wrappingProduct = wrappingProduct?.variants?.find(
                    (variant) => variant.id === wrappingGift.variantId,
                  );
                  break;
                }
              }

              // Find the wrapping image
              if (wrappingProduct) {
                for (const productArray of productData) {
                  for (const product of productArray) {
                    wrappingImage = product.images?.find(
                      (image) => image.id === wrappingProduct.image_id,
                    );
                    if (wrappingImage) {
                      break;
                    }
                  }
                  if (wrappingImage) {
                    break;
                  }
                }
              }

              return (
                <div
                  className="image-wrapper"
                  onClick={() => handleRemoveProduct(index, 'wrappingGift')}
                >
                  <div key={wrappingProduct?.id} className="gifting-image-container-summary">
                    <img
                      src={wrappingImage?.src}
                      alt={wrappingProduct?.title}
                      className="gift-image-bottom-summary gift-image-in-summary-container"
                    />
                  </div>
                  <div className="remove-overlay">REMOVE</div>
                </div>
              );
            })
          ) : (
            <div className="gifting-image-container-summary">
              <img
                src="https://cdn.shopify.com/s/files/1/0605/5100/4348/files/6.png?v=1716438788"
                alt="Placeholder"
                className="gift-image-bottom-summary gift-image-in-summary-container"
              />
            </div>
          )}

          {giftingCart?.wishCardGift !== undefined && giftingCart?.wishCardGift?.length > 0 ? (
            giftingCart.wishCardGift?.map((wishCardGift, index) => {
              let wishcardProductImage = null;

              // Check if variantId exists and is a number
              const variantId = wishCardGift.variantId;

              if (variantId !== undefined) {
                // Iterate through productData to find the matching image
                if (productData) {
                  for (const productArray of productData) {
                    for (const product of productArray) {
                      wishcardProductImage = product.images?.find((image) =>
                        image.variant_ids?.includes(variantId as any),
                      );
                      if (wishcardProductImage) {
                        break;
                      }
                    }
                    if (wishcardProductImage) {
                      break;
                    }
                  }
                }
              }
              return (
                <div
                  className="image-wrapper"
                  onClick={() => handleRemoveProduct(index, 'wishCardGift')}
                >
                  <div key={wishcardProductImage?.id} className="gifting-image-container-summary">
                    <img
                      src={wishcardProductImage?.src}
                      className="gift-image-bottom-summary gift-image-in-summary-container"
                    />
                  </div>
                  <div className="remove-overlay">REMOVE</div>
                </div>
              );
            })
          ) : (
            <div className="gifting-image-container-summary">
              <img
                src="https://cdn.shopify.com/s/files/1/0605/5100/4348/files/5.png?v=1716438788"
                alt="Placeholder"
                className="gift-image-bottom-summary gift-image-in-summary-container"
              />
            </div>
          )}
        </div>
        {/* {window.innerWidth <= 1200 ? ( */}
        {/* <div style={{ marginRight: '10rem' }} onClick={() => onNextStep(giftId)}>
                        {allgifts.length === [...giftingCategory.filter((e) => e === 'mainProduct'), ...giftingCategory.filter((e) => e === 'accessoriesProduct')].length ? (
                            <button>
                                <span style={{ marginRight: '0.5rem', color: '#6f1920', fontSize: "10px" }}>
                                    ADD BOX AND WRAPPING
                                </span>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth="1.5"
                                    stroke="currentColor"
                                    style={{ width: '10px', color: '#6f1920' }}
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="m8.25 4.5 7.5 7.5-7.5 7.5"
                                    />
                                </svg>
                            </button>
                        ) : null}
                    </div> */}
        {/* ) : (
                    <div style={{ marginRight: '1rem' }} onClick={() => onNextStep(giftId)}>
                        {allgifts.length === [...giftingCategory.filter((e) => e === 'mainProduct'), ...giftingCategory.filter((e) => e === 'accessoriesProduct')].length ? (
                            <button style={{ display: 'flex', alignItems: 'center' }}>
                                <div>
                                    <span style={{ marginRight: '0.5rem', color: '#6f1920' }}>
                                        ADD BOX AND WRAPPINGc sv
                                    </span>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth="1.5"
                                        stroke="currentColor"
                                        style={{ width: '25px', color: '#6f1920' }}
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="m8.25 4.5 7.5 7.5-7.5 7.5"
                                        />
                                    </svg>
                                </div>
                            </button>
                        ) : null}
                    </div>
                )} */}
      </div>

      <ProductOptionsModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        selectedProduct={selectedProduct}
        selectedOptions={selectedOptions}
        selectedComboProducts={selectedComboProducts}
        swatchMap={swatchMap}
        handleSelectOption={handleSelectOption}
        addToBox={addToBox}
        alertMessage={alertMessage}
      />
      {/* for main product */}
      {productData?.map((mainProduct, index) =>
        giftingCategory[index] === 'mainProduct' && mainProduct && mainProduct.length > 0 ? (
          <div key={index} ref={(el) => (disclosureRefs.current[index] = el)}>
            <Disclosure defaultOpen={index === 0}>
              {({ open }) => (
                <>
                  <Disclosure.Button
                    className="gifting-product-list-container"
                    onClick={() => setOpenIndex(open ? null : index)}
                  >
                    <div className="product-disclosure">
                      <div>
                        <h5 style={{ marginTop: '14px' }}>Main Product</h5>
                        <p>Add up to 1 items to your gift box.</p>
                      </div>
                      <div style={{ alignContent: 'center' }}>
                        <ChevronDownIcon
                          style={{
                            width: '1.5rem',
                            height: '1.5rem',
                            transform: open ? 'rotate(0deg)' : 'rotate(180deg)',
                          }}
                        />
                      </div>
                    </div>
                  </Disclosure.Button>
                  <Disclosure.Panel>
                    <div className="product-grid">
                      {mainProduct?.map((p, i) => {
                        const getPriceOrRange = (selectedOptions: SelectedOption | null) => {
                          const formatPrice = (price: number, currency: string) => {
                            if (currency === 'Rp') {
                              // currency Rp, remove 2 decimal places.
                              return price.toLocaleString(undefined, {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                              });
                            } else {
                              // Other currencies, format with 2 decimal places.
                              return price.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              });
                            }
                          };

                          if (p?.variants?.length === 1) {
                            const variant = p?.variants[0];
                            const price = parseFloat(variant.price);
                            if (!isNaN(price)) {
                              return (
                                shopCurrencyValue + ' ' + formatPrice(price, shopCurrencyValue)
                              );
                            } else {
                              return ''; // Handle invalid price
                            }
                          }

                          const prices = (p?.variants || [])
                            .filter((variant) => {
                              return Object.keys(selectedOptions || {}).every((key) => {
                                return (
                                  (selectedOptions || {})[key as OptionKeys] ===
                                  variant[key as OptionKeys]
                                );
                              });
                            })
                            .map((variant) => parseFloat(variant.price))
                            .filter((price) => !isNaN(price)); // Filter out invalid prices

                          if (prices.length === 0) {
                            return ''; // Handle case where there are no valid prices
                          }

                          if (prices.every((price) => price === prices[0])) {
                            return (
                              shopCurrencyValue + ' ' + formatPrice(prices[0], shopCurrencyValue)
                            );
                          } else {
                            const minPrice = Math.min(...prices);
                            const maxPrice = Math.max(...prices);
                            return `${shopCurrencyValue}${formatPrice(
                              minPrice,
                              shopCurrencyValue,
                            )} - ${shopCurrencyValue}${formatPrice(maxPrice, shopCurrencyValue)}`;
                          }
                        };
                        const price = getPriceOrRange(selectedOptions[p?.id as any]);
                        const isOutOfStock = p?.variants?.every(isVariantOutOfStock);

                        return (
                          // for nada to continue
                          // ** slider for image variant
                          // ** click gambar can view variant image with slider
                          // <Slider {...settings}>
                          <div key={p.id} className="product-item-swiper">
                            <Swiper
                              spaceBetween={50}
                              slidesPerView={1}
                              navigation
                              // pagination={{ clickable: true }}
                              modules={[Navigation, Pagination]}
                            >
                              {p.images?.map((image, idx) => (
                                <SwiperSlide key={idx}>
                                  <img src={image.src} alt={p.title} className="product-image" />
                                </SwiperSlide>
                              ))}
                            </Swiper>
                            {/* <img
                                                            src={p.image.src}
                                                            alt={p.title}
                                                            className="product-image"
                                                        /> */}
                            <div className="product-name-container">
                              <div className="product-name">{p.title}</div>
                            </div>
                            <div className="product-item-body">
                              <p className="product-price">
                                {isOutOfStock ? 'Out of Stock' : `RM ${price}`}
                              </p>
                            </div>
                            <div className="product-item-body">
                              <button
                                disabled={isOutOfStock ? true : false}
                                className="add-to-box-button"
                                style={addToBoxStyle(p, i, 'mainGift', index - 1)}
                                onClick={() =>
                                  handleOpenModal(p, i, 'mainGift', index, shopCurrencyValue)
                                }
                              >
                                {addToBoxText(p, i, 'mainGift', index - 1)}
                              </button>
                            </div>
                          </div>
                          // </Slider>
                        );
                      })}
                    </div>
                  </Disclosure.Panel>
                </>
              )}
            </Disclosure>
          </div>
        ) : null,
      )}

      {/* for accessories product */}
      {productData?.map((accessories, index) =>
        // index >= 1 && index < 10 &&
        giftingCategory[index] === 'accessoriesProduct' && accessories && accessories.length > 0 ? (
          <div key={index} ref={(el) => (disclosureRefs.current[index] = el)}>
            <Disclosure>
              {({ open }) => {
                return (
                  <>
                    <Disclosure.Button
                      className="gifting-product-list-container"
                      onClick={() => setOpenIndex(open ? null : index)}
                    >
                      <div className="product-disclosure">
                        <div>
                          <h5 style={{ marginTop: '14px' }}>Accessories</h5>
                          <p>Add up to 1 items to your gift box.</p>
                        </div>
                        <div style={{ alignContent: 'center' }}>
                          <ChevronDownIcon
                            style={{
                              width: '1.5rem',
                              height: '1.5rem',
                              transform: open ? 'rotate(0deg)' : 'rotate(180deg)',
                            }}
                          />
                        </div>
                      </div>
                    </Disclosure.Button>
                    <Disclosure.Panel>
                      <div className="product-grid">
                        {accessories?.map((p, i) => {
                          const getPriceOrRange = (selectedOptions: SelectedOption | null) => {
                            const formatPrice = (price: number, currency: string) => {
                              if (currency === 'Rp') {
                                // currency Rp, remove 2 decimal places.
                                return price.toLocaleString(undefined, {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                });
                              } else {
                                // Other currencies, format with 2 decimal places.
                                return price.toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                });
                              }
                            };

                            if (p?.variants?.length === 1) {
                              const variant = p?.variants[0];
                              const price = parseFloat(variant.price);
                              if (!isNaN(price)) {
                                return (
                                  shopCurrencyValue + ' ' + formatPrice(price, shopCurrencyValue)
                                );
                              } else {
                                return ''; // Handle invalid price
                              }
                            }

                            const prices = (p?.variants || [])
                              .filter((variant) => {
                                return Object.keys(selectedOptions || {}).every((key) => {
                                  return (
                                    (selectedOptions || {})[key as OptionKeys] ===
                                    variant[key as OptionKeys]
                                  );
                                });
                              })
                              .map((variant) => parseFloat(variant.price))
                              .filter((price) => !isNaN(price)); // Filter out invalid prices

                            if (prices.length === 0) {
                              return ''; // Handle case where there are no valid prices
                            }

                            if (prices.every((price) => price === prices[0])) {
                              return (
                                shopCurrencyValue + ' ' + formatPrice(prices[0], shopCurrencyValue)
                              );
                            } else {
                              const minPrice = Math.min(...prices);
                              const maxPrice = Math.max(...prices);
                              return `${shopCurrencyValue}${formatPrice(
                                minPrice,
                                shopCurrencyValue,
                              )} - ${shopCurrencyValue}${formatPrice(maxPrice, shopCurrencyValue)}`;
                            }
                          };
                          const price = getPriceOrRange(selectedOptions[p?.id as any]);
                          const isOutOfStock = p?.variants?.every(isVariantOutOfStock);
                          let selectedProduct = false;
                          giftingCart?.['accessoriesGift']?.map((e, giftIndex) => {
                            if (giftingCategory?.filter((e) => e === 'mainProduct')?.length > 1) {
                              // if (index === giftIndex) {
                              if (e?.productId === p.id) {
                                selectedProduct = true;
                              }
                              // }
                            } else {
                              if (index === giftIndex + 1) {
                                if (e?.productId === p.id) {
                                  selectedProduct = true;
                                }
                              }
                            }
                          });
                          return (
                            <div key={p.id} className="product-item-swiper">
                              <Swiper
                                spaceBetween={50}
                                slidesPerView={1}
                                navigation
                                // pagination={{ clickable: true }}
                                modules={[Navigation, Pagination]}
                              >
                                {p.images?.map((image, idx) => (
                                  <SwiperSlide key={idx}>
                                    <img src={image.src} alt={p.title} className="product-image" />
                                  </SwiperSlide>
                                ))}
                              </Swiper>
                              {/* <img
                                                                src={p.image.src}
                                                                alt={p.title}
                                                                className="product-image"
                                                            /> */}
                              <div className="product-name-container">
                                <div className="product-name">{p.title}</div>
                              </div>
                              <div className="product-item-body">
                                <p className="product-price">
                                  {/* RM {p.variants?.[0].price} */}
                                  {isOutOfStock ? 'Out of Stock' : `RM ${price}`}
                                </p>
                              </div>
                              <div className="product-item-body">
                                {/* <button
                                                            disabled={isOutOfStock ? true : false}
                                                            className="add-to-box-button"
                                                            style={addToBoxStyle(
                                                                p,
                                                                i,
                                                                'accessoriesGift',
                                                                index,
                                                            )}
                                                            onClick={() =>
                                                                handleOpenModal(
                                                                    p,
                                                                    i,
                                                                    'accessoriesGift',
                                                                    index,
                                                                    shopCurrencyValue,
                                                                )
                                                            }
                                                        >
                                                            {addToBoxText(
                                                                p,
                                                                i,
                                                                'accessoriesGift',
                                                                index,
                                                            )}
                                                        </button> */}

                                <button
                                  disabled={isOutOfStock ? true : false}
                                  className="add-to-box-button"
                                  style={
                                    selectedProduct === false
                                      ? {
                                          border: '1.5px solid black',
                                          color: 'black',
                                          marginTop: '30px',
                                        }
                                      : {
                                          backgroundColor: '#6f1920',
                                          color: 'white',
                                        }
                                  }
                                  onClick={() =>
                                    handleOpenModal(
                                      p,
                                      i,
                                      'accessoriesGift',
                                      index,
                                      shopCurrencyValue,
                                    )
                                  }
                                >
                                  {' '}
                                  {selectedProduct === false ? 'Add To Box' : 'Added To Box'}
                                </button>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </Disclosure.Panel>
                  </>
                );
              }}
            </Disclosure>
          </div>
        ) : null,
      )}

      {allgifts.length ===
      [
        ...giftingCategory.filter((e) => e === 'mainProduct'),
        ...giftingCategory.filter((e) => e === 'accessoriesProduct'),
      ].length ? (
        <button className="button-next-page" onClick={() => onNextStep(giftId)}>
          Next step: Add Box and Wrapping
        </button>
      ) : null}
    </div>
  );
};

const AddPersonalMessagePage: React.FC<PersonalMessage> = ({
  productData,
  onBack,
  onNext,
  onGiftChange,
  giftingCart,
  setGiftingCart,
  onChangeRecipientName,
  onChangeMessage,
  giftId,
  cartLoading,
  setCartLoading,
  giftingCategory,
}) => {
  const [noMessage, setNoMessage] = useState(false);
  const [selectedWishcard, setSelectedWishcard] = useState<number | null>(null);

  // const [templateMessage, setTemplateMessage] = useState("");
  // const [displayMessage, setDisplayMesage] = useState("");
  // const [disabled, setDisabled] = useState(false);

  const [allgifts, setAllGift] = useState<any[]>([]);
  useEffect(() => {
    const allGifts = [
      ...(giftingCart.wishCardGift ? giftingCart.wishCardGift.filter((item) => item != null) : []),
    ];
    setAllGift(allGifts);
  }, [giftingCart]);

  const isVariantOutOfStock = (variant: VariantsEntity) => {
    return variant.inventory_quantity === 0 && variant.inventory_policy === 'deny';
  };
  const handleCheckboxChange = (event: any) => {
    setNoMessage(!noMessage);
    if (!noMessage) {
      onChangeMessage(event);
    }
  };

  const handleWishcardSelect = (
    productId: number,
    variantId: any,
    type: GiftType,
    index: number,
  ) => {
    if (type === 'wishCardGift') {
      onGiftChange(variantId, productId, type, index);
    }
  };

  const handleChangeRecipient = (event: any) => {
    onChangeRecipientName(event);
  };

  const handleChangeMessage = (event: any) => {
    onChangeMessage(event);
  };

  const handleRemoveProduct = (index: number, type: GiftType) => {
    if (type === 'mainGift' || type === 'accessoriesGift') {
      const newData = giftingCart?.[type] ? [...giftingCart[type]] : [];
      if (newData?.[index] !== undefined) {
        newData[index] = {} as any;
      }
      const newGiftingCart = giftingCart?.[type]?.splice(index, 1);
      setGiftingCart((prev: any) => ({
        ...prev,
        [type]: null,
      }));
    } else {
      const newData = giftingCart?.[type] ? [...giftingCart[type]] : [];
      if (newData?.[index] !== undefined) {
        newData[index] = {};
      }
      const newGiftingCart = giftingCart?.[type]?.splice(index, 1);
      setGiftingCart((prev: any) => ({
        ...prev,
        [type]: null,
      }));
    }
  };

  // const handleGenerate = () => {
  //     setDisabled(true);
  //     setTemplateMessage(getRandomElement(WISH));
  //     const wish = getRandomElement(WISH)
  //     onChangeMessage(wish);
  //   };

  // const getRandomElement = (arr: string[]) => {
  //     let lastIndex = -1;
  //     return function () {
  //     let randomIndex;
  //     do {
  //         randomIndex = Math.floor(Math.random() * arr.length);
  //     } while (randomIndex === lastIndex);
  //     lastIndex = randomIndex;
  //     return arr[randomIndex];
  //     };
  // };

  const remainingCharacters =
    100 -
    ((giftingCart.wishCardGift as any)?.[0].message.length !== undefined
      ? (giftingCart.wishCardGift as any)?.[0].message.length
      : 0);
  return (
    <div className="container">
      <div className="box-button-container">
        <button onClick={onBack}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            style={{ width: '20px' }}
          >
            <path
              fill-rule="evenodd"
              d="M11.78 5.22a.75.75 0 0 1 0 1.06L8.06 10l3.72 3.72a.75.75 0 1 1-1.06 1.06l-4.25-4.25a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z"
              clip-rule="evenodd"
            />
          </svg>
          Select Box and Wrapping
        </button>
        {allgifts.length === [...giftingCategory.filter((e) => e === 'wishCard')].length &&
        allgifts[0].productId !== undefined ? (
          <button onClick={() => onNext(giftId)}>
            Review Gift
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              style={{ width: '20px' }}
            >
              <path
                fill-rule="evenodd"
                d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
        ) : null}
      </div>
      <div className="gifting-selected-product-container">
        <div className="left">
          <h1>Personalize Your Gift</h1>
          <p>Enter recipient's name, message and choose your favourite wishcard.</p>
          <div className="recipient-name-field">
            <input
              type="text"
              id="recipientName"
              value={giftingCart.wishCardGift?.[0].recipientName}
              onChange={handleChangeRecipient}
              placeholder="Recipient's Name *"
              className="form-control"
              disabled={noMessage === true ? true : false}
            />
          </div>
          <div className="message-on-card-container card-message-field">
            <label htmlFor="message h3">
              <h5>Message on Card</h5>
            </label>
            <textarea
              id="message"
              value={giftingCart.wishCardGift?.[0].message}
              onChange={handleChangeMessage}
              className="form-control-area"
              disabled={noMessage === true}
              rows={4}
              style={{ resize: 'none' }}
            />
            <span>{remainingCharacters} characters remaining</span>
          </div>

          {/* <button
                        className="w-full py-4 border text-sk-white rounded-md disabled:border-sk-gray-disabled disabled:text-sk-gray-disabled"
                        onClick={handleGenerate}
                        disabled={disabled}
                    >
                        Generate a wish for me
                    </button> */}
          <div className="card-message-field-no-message">
            <input
              type="checkbox"
              id="noMessage"
              checked={noMessage}
              onChange={handleCheckboxChange}
            />
            <label htmlFor="noMessage">No Message</label>
          </div>
        </div>
        <div className="right">
          <h4>Select a Wishcard: </h4>
          <div className="wishcard-list">
            <Swiper
              modules={[Navigation, FreeMode]}
              spaceBetween={10}
              slidesPerView={'auto'}
              navigation
              freeMode={true}
            >
              {productData?.map((wishCard, wishCardIndex) => {
                if (
                  giftingCategory[wishCardIndex] === 'wishCard' &&
                  wishCard &&
                  wishCard.length > 0
                ) {
                  return wishCard.map((p, i) =>
                    p.variants
                      ?.filter((e) => e.inventory_quantity > 0 && e.inventory_policy === 'deny')
                      ?.map((variant, variantIndex) => {
                        let wishCardImage = null;

                        if (productData) {
                          for (const productArray of productData) {
                            const product = productArray.find((product) =>
                              product.images?.some((image) => image.id === variant?.image_id),
                            );
                            if (product) {
                              wishCardImage = product.images?.find(
                                (image) => image.id === variant?.image_id,
                              );
                              if (wishCardImage) {
                                break;
                              }
                            }
                          }
                        }

                        const isOutOfStock = isVariantOutOfStock(variant);

                        return (
                          <SwiperSlide key={variantIndex} className="wrapping-item-slide">
                            <div
                              className={`wishcard-item ${
                                window.innerWidth <= 1200 ? 'mobile' : 'desktop'
                              } ${
                                variant.id === giftingCart.wishCardGift?.[0]?.variantId
                                  ? 'selected'
                                  : ''
                              }`}
                              onClick={
                                !isOutOfStock
                                  ? () =>
                                      handleWishcardSelect(
                                        variant.product_id,
                                        variant.id,
                                        'wishCardGift',
                                        i,
                                      )
                                  : undefined
                              }
                            >
                              {wishCardImage && (
                                <img
                                  src={wishCardImage.src}
                                  alt={wishCardImage.src}
                                  className="wishcard-image"
                                />
                              )}
                              <div className="product-item-body">
                                <p className="product-price">
                                  {isOutOfStock
                                    ? 'Out of Stock'
                                    : parseFloat(variant?.price) === 0.0
                                    ? 'Free!'
                                    : `RM ${variant?.price}`}
                                </p>
                              </div>
                            </div>
                          </SwiperSlide>
                        );
                      }),
                  );
                }
                return null;
              })}
            </Swiper>
          </div>
        </div>
      </div>
      {allgifts.length === [...giftingCategory.filter((e) => e === 'wishCard')].length &&
      allgifts[0].productId !== undefined ? (
        <button className="button-next-page" onClick={() => onNext(giftId)}>
          Next step: Let's Review Gift!
        </button>
      ) : null}
      <div className="mobile-selected-products-container active flex justify-between">
        <div className="gifting-image-bottom-container">
          {giftingCart?.mainGift !== undefined && giftingCart?.mainGift?.length > 0 ? (
            giftingCart.mainGift?.map((mainGift, index) => {
              const maingift = giftingCart.mainGift?.[index];

              let productMainGift = {} as GiftingProduct;
              productData?.map((product) => {
                product.map((p) => {
                  if (p.id === maingift?.productId) {
                    productMainGift = p;
                  }
                });
              });
              let mainProductImage = {} as any;
              mainProductImage = productMainGift?.images?.find((image) =>
                image.variant_ids?.find((variant) => variant === maingift?.variantId),
              );
              if (mainProductImage === undefined) {
                mainProductImage = productMainGift.image;
              }
              const placeholderUrls = [
                'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/1_8652a78a-7268-4964-a090-b5cc8894e4a7.png?v=1715706345',
              ];

              return (
                <div className="gifting-image-container-summary">
                  {mainProductImage?.src ? (
                    <div
                      className="image-wrapper"
                      onClick={() => handleRemoveProduct(index, 'mainGift')}
                    >
                      <img
                        src={
                          mainProductImage?.src ? mainProductImage?.src : productMainGift?.image.src
                        }
                        alt={
                          mainProductImage?.src ? mainProductImage?.src : productMainGift?.image.src
                        }
                        className="gift-image-bottom-summary gift-image-in-summary-container"
                      />
                      <div className="remove-overlay">REMOVE</div>
                    </div>
                  ) : (
                    <img
                      src={placeholderUrls[0]}
                      alt="Placeholder"
                      className="gift-image-bottom-summary gift-image-in-summary-container"
                    />
                  )}
                </div>
              );
            })
          ) : (
            <>
              {giftingCategory
                .filter((gc) => gc === 'mainProduct')
                .map((mainProduct, i) => {
                  return (
                    <div className="gifting-image-container-summary">
                      <img
                        src="https://cdn.shopify.com/s/files/1/0605/5100/4348/files/1_8652a78a-7268-4964-a090-b5cc8894e4a7.png?v=1715706345"
                        alt="Placeholder"
                        className="gift-image-bottom-summary gift-image-in-summary-container"
                      />
                    </div>
                  );
                })}
            </>
          )}
          {giftingCart?.accessoriesGift !== undefined && giftingCart?.accessoriesGift?.length > 0
            ? giftingCart?.accessoriesGift?.map((product, index, array) => {
                const accessoriesGift = giftingCart.accessoriesGift?.[index];

                let productAccessories = {} as GiftingProduct;
                productData?.map((product) => {
                  product.map((p) => {
                    if (p.id === accessoriesGift?.productId) {
                      productAccessories = p;
                    }
                  });
                });
                let accessoriesProductImage = {} as any;
                accessoriesProductImage = productAccessories?.images?.find((image) =>
                  image.variant_ids?.find((variant) => variant === accessoriesGift?.variantId),
                );
                if (accessoriesProductImage === undefined) {
                  accessoriesProductImage = productAccessories.image;
                }

                const placeholderUrls = [
                  'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/2_685be79b-3fd7-4c5e-9f58-7ce9a6db1b4f.png?v=1715706345',
                  'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/3_388fb02d-8c3b-4e37-96a2-ed4a002c0ac5.png?v=1715706346',
                  'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/4_bea88dc1-f447-4627-90d2-b65b36d91aa6.png?v=1715706345',
                  'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/3_388fb02d-8c3b-4e37-96a2-ed4a002c0ac5.png?v=1715706346',
                  'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/4_bea88dc1-f447-4627-90d2-b65b36d91aa6.png?v=1715706345',
                  'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/3_388fb02d-8c3b-4e37-96a2-ed4a002c0ac5.png?v=1715706346',
                  'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/4_bea88dc1-f447-4627-90d2-b65b36d91aa6.png?v=1715706345',
                  'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/3_388fb02d-8c3b-4e37-96a2-ed4a002c0ac5.png?v=1715706346',
                  'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/4_bea88dc1-f447-4627-90d2-b65b36d91aa6.png?v=1715706345',
                  'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/3_388fb02d-8c3b-4e37-96a2-ed4a002c0ac5.png?v=1715706346',
                  'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/4_bea88dc1-f447-4627-90d2-b65b36d91aa6.png?v=1715706345',
                ];

                return (
                  <div key={index} className="gifting-image-container-summary">
                    {accessoriesProductImage?.src ? (
                      <div
                        className="image-wrapper"
                        onClick={() => handleRemoveProduct(index, 'accessoriesGift')}
                      >
                        <img
                          src={
                            accessoriesProductImage?.src
                              ? accessoriesProductImage?.src
                              : productAccessories?.image.src
                          }
                          alt={
                            accessoriesProductImage?.src
                              ? accessoriesProductImage?.src
                              : productAccessories?.image.src
                          }
                          className="gift-image-bottom-summary gift-image-in-summary-container"
                        />
                        <div className="remove-overlay">REMOVE</div>
                      </div>
                    ) : (
                      <img
                        src={placeholderUrls[index]}
                        alt="Placeholder"
                        className="gift-image-bottom-summary gift-image-in-summary-container"
                      />
                    )}
                  </div>
                );
              })
            : giftingCategory
                .filter((gc) => gc === 'accessoriesProduct')
                .map((accessoriesProduct, index) => {
                  const placeholderUrls = [
                    'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/2_685be79b-3fd7-4c5e-9f58-7ce9a6db1b4f.png?v=1715706345',
                    'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/3_388fb02d-8c3b-4e37-96a2-ed4a002c0ac5.png?v=1715706346',
                    'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/4_bea88dc1-f447-4627-90d2-b65b36d91aa6.png?v=1715706345',
                    'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/3_388fb02d-8c3b-4e37-96a2-ed4a002c0ac5.png?v=1715706346',
                    'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/4_bea88dc1-f447-4627-90d2-b65b36d91aa6.png?v=1715706345',
                    'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/3_388fb02d-8c3b-4e37-96a2-ed4a002c0ac5.png?v=1715706346',
                    'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/4_bea88dc1-f447-4627-90d2-b65b36d91aa6.png?v=1715706345',
                    'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/3_388fb02d-8c3b-4e37-96a2-ed4a002c0ac5.png?v=1715706346',
                    'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/4_bea88dc1-f447-4627-90d2-b65b36d91aa6.png?v=1715706345',
                    'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/3_388fb02d-8c3b-4e37-96a2-ed4a002c0ac5.png?v=1715706346',
                    'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/4_bea88dc1-f447-4627-90d2-b65b36d91aa6.png?v=1715706345',
                  ];
                  return (
                    <div key={index} className="gifting-image-container-summary">
                      <img
                        src={placeholderUrls[index]}
                        alt="Placeholder"
                        className="gift-image-bottom-summary gift-image-in-summary-container"
                      />
                    </div>
                  );
                })}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            style={{ width: '12px' }}
          >
            <path d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z" />
          </svg>

          {giftingCart?.boxGift !== undefined && giftingCart?.boxGift?.length > 0 ? (
            giftingCart.boxGift?.map((boxGift, index) => {
              let boxProduct = null;
              if (productData) {
                for (const productArray of productData) {
                  boxProduct = productArray.find((product) => product.id === boxGift.productId);
                  if (boxProduct) {
                    break;
                  }
                }
              }

              return (
                <div
                  className="image-wrapper"
                  onClick={() => handleRemoveProduct(index, 'boxGift')}
                >
                  <div className="gifting-image-container-summary">
                    <img
                      src={boxProduct?.image?.src}
                      alt="Placeholder"
                      className="gift-image-bottom-summary gift-image-in-summary-container"
                    />
                  </div>
                  <div className="remove-overlay">REMOVE</div>
                </div>
              );
            })
          ) : (
            <div className="gifting-image-container-summary">
              <img
                src="https://cdn.shopify.com/s/files/1/0605/5100/4348/files/7.png?v=1716438789"
                alt="Placeholder"
                className="gift-image-bottom-summary gift-image-in-summary-container"
              />
            </div>
          )}
          {giftingCart?.wrappingGift !== undefined && giftingCart?.wrappingGift?.length > 0 ? (
            giftingCart.wrappingGift?.map((wrappingGift, index) => {
              let wrappingProduct = null;
              let wrappingImage = null;

              // Find the wrapping product
              for (const productArray of productData) {
                wrappingProduct = productArray.find((product) =>
                  product.variants?.some((variant) => variant.id === wrappingGift.variantId),
                );

                if (wrappingProduct) {
                  wrappingProduct = wrappingProduct?.variants?.find(
                    (variant) => variant.id === wrappingGift.variantId,
                  );
                  break;
                }
              }

              // Find the wrapping image
              if (wrappingProduct) {
                for (const productArray of productData) {
                  for (const product of productArray) {
                    wrappingImage = product.images?.find(
                      (image) => image.id === wrappingProduct.image_id,
                    );
                    if (wrappingImage) {
                      break;
                    }
                  }
                  if (wrappingImage) {
                    break;
                  }
                }
              }

              return (
                <div
                  className="image-wrapper"
                  onClick={() => handleRemoveProduct(index, 'wrappingGift')}
                >
                  <div key={wrappingProduct?.id} className="gifting-image-container-summary">
                    <img
                      src={wrappingImage?.src}
                      alt={wrappingProduct?.title}
                      className="gift-image-bottom-summary gift-image-in-summary-container"
                    />
                  </div>
                  <div className="remove-overlay">REMOVE</div>
                </div>
              );
            })
          ) : (
            <div className="gifting-image-container-summary">
              <img
                src="https://cdn.shopify.com/s/files/1/0605/5100/4348/files/6.png?v=1716438788"
                alt="Placeholder"
                className="gift-image-bottom-summary gift-image-in-summary-container"
              />
            </div>
          )}

          {giftingCart?.wishCardGift !== undefined && giftingCart?.wishCardGift?.length > 0 ? (
            giftingCart.wishCardGift?.map((wishCardGift, index) => {
              let wishcardProductImage = null;

              // Check if variantId exists and is a number
              const variantId = wishCardGift.variantId;

              if (variantId !== undefined) {
                // Iterate through productData to find the matching image
                if (productData) {
                  for (const productArray of productData) {
                    for (const product of productArray) {
                      wishcardProductImage = product.images?.find((image) =>
                        image.variant_ids?.includes(variantId as any),
                      );
                      if (wishcardProductImage) {
                        break;
                      }
                    }
                    if (wishcardProductImage) {
                      break;
                    }
                  }
                }
              }
              return (
                <div
                  className="image-wrapper"
                  onClick={() => handleRemoveProduct(index, 'wishCardGift')}
                >
                  <div key={wishcardProductImage?.id} className="gifting-image-container-summary">
                    <img
                      src={wishcardProductImage?.src}
                      className="gift-image-bottom-summary gift-image-in-summary-container"
                    />
                  </div>
                  <div className="remove-overlay">REMOVE</div>
                </div>
              );
            })
          ) : (
            <div className="gifting-image-container-summary">
              <img
                src="https://cdn.shopify.com/s/files/1/0605/5100/4348/files/5.png?v=1716438788"
                alt="Placeholder"
                className="gift-image-bottom-summary gift-image-in-summary-container"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const AddBoxandWrappingPage: React.FC<AddonBoxWrapping> = ({
  productData,
  onBack,
  onNext,
  onGiftChange,
  giftingCart,
  giftId,
  setGiftingCart,
  cartLoading,
  setCartLoading,
  giftingCategory,
}) => {
  const [allgifts, setAllGift] = useState<any[]>([]);
  useEffect(() => {
    const allGifts = [
      ...(giftingCart.boxGift ? giftingCart.boxGift.filter((item) => item != null) : []),
      ...(giftingCart.wrappingGift ? giftingCart.wrappingGift.filter((item) => item != null) : []),
    ];
    setAllGift(allGifts);
  }, [giftingCart]);
  const handleChange = (productId: number, variantId: any, type: GiftType, index: number) => {
    onGiftChange(variantId, productId, type, index);
  };
  const isVariantOutOfStock = (variant: VariantsEntity) => {
    return variant.inventory_quantity === 0 && variant.inventory_policy === 'deny';
  };
  const handleRemoveProduct = (index: number, type: GiftType) => {
    if (type === 'mainGift' || type === 'accessoriesGift') {
      const newData = giftingCart?.[type] ? [...giftingCart[type]] : [];
      if (newData?.[index] !== undefined) {
        newData[index] = {} as any;
      }
      const newGiftingCart = giftingCart?.[type]?.splice(index, 1);
      setGiftingCart((prev: any) => ({
        ...prev,
        [type]: null,
      }));
    } else {
      const newData = giftingCart?.[type] ? [...giftingCart[type]] : [];
      if (newData?.[index] !== undefined) {
        newData[index] = {};
      }
      const newGiftingCart = giftingCart?.[type]?.splice(index, 1);
      setGiftingCart((prev: any) => ({
        ...prev,
        [type]: null,
      }));
    }
  };
  return (
    <div className="container">
      <div className="box-button-container">
        <button onClick={onBack}>
          {' '}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            style={{ width: '20px' }}
          >
            <path
              fill-rule="evenodd"
              d="M11.78 5.22a.75.75 0 0 1 0 1.06L8.06 10l3.72 3.72a.75.75 0 1 1-1.06 1.06l-4.25-4.25a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z"
              clip-rule="evenodd"
            />
          </svg>
          Select Product
        </button>
        {allgifts.length ===
        [
          ...giftingCategory.filter((e) => e === 'box'),
          ...giftingCategory.filter((e) => e === 'wrapping'),
        ].length ? (
          <button onClick={() => onNext(giftId)}>
            Add Personal Message!
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              style={{ width: '20px' }}
            >
              <path
                fill-rule="evenodd"
                d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
        ) : null}
      </div>
      <div className="gifting-selected-product-containers">
        <h1>Personalize Box and Wrapping</h1>
        <p>Choose your favourite box and gift wrap.</p>
        <div className="flex-desktop">
          <div className="left">
            <div className="mt-3">
              <h4>Select a Box: </h4>
              <div className="boxwrapping-list">
                <Swiper
                  modules={[Navigation, FreeMode]}
                  spaceBetween={10}
                  slidesPerView={'auto'}
                  navigation
                  freeMode={true}
                >
                  {productData?.map((p, index) => {
                    if (giftingCategory[index] === 'box' && p && p.length > 0) {
                      return p.map((box, i) => {
                        const isOutOfStock = box?.variants?.every(isVariantOutOfStock);
                        return (
                          <SwiperSlide key={box.id} className="wrapping-item-slide">
                            <div
                              className={`box-item ${
                                window.innerWidth <= 1200 ? 'mobile' : 'desktop'
                              } ${box.id === giftingCart.boxGift?.[0].productId ? 'selected' : ''}`}
                              onClick={
                                !isOutOfStock
                                  ? () => handleChange(box.id, box.variants?.[0].id, 'boxGift', i)
                                  : undefined
                              }
                            >
                              <div className="center-image-container">
                                <img
                                  src={box.image.src}
                                  alt={box.title}
                                  className="boxwrapping-image"
                                />
                              </div>
                              <div className="product-name-container">
                                <div className="boxwrapping-name">{box.title}</div>
                              </div>
                              <div className="product-item-body">
                                <p className="boxwrapping-price">
                                  {isOutOfStock ? 'Out of Stock' : `RM ${box.variants?.[0].price}`}
                                </p>
                              </div>
                            </div>
                          </SwiperSlide>
                        );
                      });
                    }
                    return null;
                  })}
                </Swiper>
              </div>
            </div>
          </div>
          <div className="wrapping-right">
            <h4 className="mt-3">Select Wrapping: </h4>
            <Swiper
              modules={[Navigation, FreeMode]}
              spaceBetween={10}
              slidesPerView={'auto'}
              navigation
              freeMode={true}
            >
              {productData?.map((w, wrappingIndex) => {
                if (giftingCategory[wrappingIndex] === 'wrapping' && w && w.length > 0) {
                  return w.map((wrapping, productIndex) =>
                    wrapping.variants
                      ?.filter((e) => e.inventory_quantity > 0 && e.inventory_policy === 'deny')
                      ?.map((wrappingVariant, variantIndex) => {
                        const wrappingImage = wrapping.images?.find(
                          (image) => image.id === wrappingVariant.image_id,
                        );
                        const isOutOfStock = isVariantOutOfStock(wrappingVariant);

                        return (
                          <SwiperSlide key={variantIndex} className="wrapping-item-slide">
                            <div
                              className={`wrapping-item ${
                                window.innerWidth <= 1200 ? 'mobile' : 'desktop'
                              } ${
                                wrappingVariant.id === giftingCart.wrappingGift?.[0].variantId
                                  ? 'selected'
                                  : ''
                              }`}
                              onClick={
                                !isOutOfStock
                                  ? () =>
                                      handleChange(
                                        wrappingVariant.product_id,
                                        wrappingVariant.id,
                                        'wrappingGift',
                                        productIndex,
                                      )
                                  : undefined
                              }
                            >
                              <div className="center-image-container">
                                <img
                                  src={wrappingImage?.src}
                                  alt={wrapping.title}
                                  className="boxwrapping-image"
                                />
                              </div>
                              <div className="product-name-container">
                                <div className="boxwrapping-name">{wrappingVariant.title}</div>
                              </div>
                              <div className="product-item-body">
                                <p className="boxwrapping-price">
                                  {isOutOfStock ? 'Out of Stock' : `RM ${wrappingVariant.price}`}
                                </p>
                              </div>
                            </div>
                          </SwiperSlide>
                        );
                      }),
                  );
                }
                return null;
              })}
            </Swiper>
          </div>
        </div>
      </div>
      {allgifts.length ===
      [
        ...giftingCategory.filter((e) => e === 'box'),
        ...giftingCategory.filter((e) => e === 'wrapping'),
      ].length ? (
        <button className="button-next-page" onClick={() => onNext(giftId)}>
          Next step: Add Personal Message!
        </button>
      ) : null}
      <div className="mobile-selected-products-container active flex justify-between">
        <div className="gifting-image-bottom-container">
          {giftingCart?.mainGift !== undefined && giftingCart?.mainGift?.length > 0 ? (
            giftingCart.mainGift?.map((mainGift, index) => {
              const maingift = giftingCart.mainGift?.[index];

              let productMainGift = {} as GiftingProduct;
              productData?.map((product) => {
                product.map((p) => {
                  if (p.id === maingift?.productId) {
                    productMainGift = p;
                  }
                });
              });
              let mainProductImage = {} as any;
              mainProductImage = productMainGift?.images?.find((image) =>
                image.variant_ids?.find((variant) => variant === maingift?.variantId),
              );
              if (mainProductImage === undefined) {
                mainProductImage = productMainGift.image;
              }
              const placeholderUrls = [
                'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/1_8652a78a-7268-4964-a090-b5cc8894e4a7.png?v=1715706345',
              ];

              return (
                <div className="gifting-image-container-summary">
                  {mainProductImage?.src ? (
                    <div
                      className="image-wrapper"
                      onClick={() => handleRemoveProduct(index, 'mainGift')}
                    >
                      <img
                        src={
                          mainProductImage?.src ? mainProductImage?.src : productMainGift?.image.src
                        }
                        alt={
                          mainProductImage?.src ? mainProductImage?.src : productMainGift?.image.src
                        }
                        className="gift-image-bottom-summary gift-image-in-summary-container"
                      />
                      <div className="remove-overlay">REMOVE</div>
                    </div>
                  ) : (
                    <img
                      src={placeholderUrls[0]}
                      alt="Placeholder"
                      className="gift-image-bottom-summary gift-image-in-summary-container"
                    />
                  )}
                </div>
              );
            })
          ) : (
            <>
              {giftingCategory
                .filter((gc) => gc === 'mainProduct')
                .map((mainProduct, i) => {
                  return (
                    <div className="gifting-image-container-summary">
                      <img
                        src="https://cdn.shopify.com/s/files/1/0605/5100/4348/files/1_8652a78a-7268-4964-a090-b5cc8894e4a7.png?v=1715706345"
                        alt="Placeholder"
                        className="gift-image-bottom-summary gift-image-in-summary-container"
                      />
                    </div>
                  );
                })}
            </>
          )}
          {giftingCart?.accessoriesGift !== undefined && giftingCart?.accessoriesGift?.length > 0
            ? giftingCart?.accessoriesGift?.map((product, index, array) => {
                const accessoriesGift = giftingCart.accessoriesGift?.[index];

                let productAccessories = {} as GiftingProduct;
                productData?.map((product) => {
                  product.map((p) => {
                    if (p.id === accessoriesGift?.productId) {
                      productAccessories = p;
                    }
                  });
                });
                let accessoriesProductImage = {} as any;
                accessoriesProductImage = productAccessories?.images?.find((image) =>
                  image.variant_ids?.find((variant) => variant === accessoriesGift?.variantId),
                );
                if (accessoriesProductImage === undefined) {
                  accessoriesProductImage = productAccessories.image;
                }

                const placeholderUrls = [
                  'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/2_685be79b-3fd7-4c5e-9f58-7ce9a6db1b4f.png?v=1715706345',
                  'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/3_388fb02d-8c3b-4e37-96a2-ed4a002c0ac5.png?v=1715706346',
                  'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/4_bea88dc1-f447-4627-90d2-b65b36d91aa6.png?v=1715706345',
                  'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/3_388fb02d-8c3b-4e37-96a2-ed4a002c0ac5.png?v=1715706346',
                  'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/4_bea88dc1-f447-4627-90d2-b65b36d91aa6.png?v=1715706345',
                  'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/3_388fb02d-8c3b-4e37-96a2-ed4a002c0ac5.png?v=1715706346',
                  'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/4_bea88dc1-f447-4627-90d2-b65b36d91aa6.png?v=1715706345',
                  'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/3_388fb02d-8c3b-4e37-96a2-ed4a002c0ac5.png?v=1715706346',
                  'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/4_bea88dc1-f447-4627-90d2-b65b36d91aa6.png?v=1715706345',
                  'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/3_388fb02d-8c3b-4e37-96a2-ed4a002c0ac5.png?v=1715706346',
                  'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/4_bea88dc1-f447-4627-90d2-b65b36d91aa6.png?v=1715706345',
                ];

                return (
                  <div key={index} className="gifting-image-container-summary">
                    {accessoriesProductImage?.src ? (
                      <div
                        className="image-wrapper"
                        onClick={() => handleRemoveProduct(index, 'accessoriesGift')}
                      >
                        <img
                          src={
                            accessoriesProductImage?.src
                              ? accessoriesProductImage?.src
                              : productAccessories?.image.src
                          }
                          alt={
                            accessoriesProductImage?.src
                              ? accessoriesProductImage?.src
                              : productAccessories?.image.src
                          }
                          className="gift-image-bottom-summary gift-image-in-summary-container"
                        />
                        <div className="remove-overlay">REMOVE</div>
                      </div>
                    ) : (
                      <img
                        src={placeholderUrls[index]}
                        alt="Placeholder"
                        className="gift-image-bottom-summary gift-image-in-summary-container"
                      />
                    )}
                  </div>
                );
              })
            : giftingCategory
                .filter((gc) => gc === 'accessoriesProduct')
                .map((accessoriesProduct, index) => {
                  const placeholderUrls = [
                    'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/2_685be79b-3fd7-4c5e-9f58-7ce9a6db1b4f.png?v=1715706345',
                    'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/3_388fb02d-8c3b-4e37-96a2-ed4a002c0ac5.png?v=1715706346',
                    'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/4_bea88dc1-f447-4627-90d2-b65b36d91aa6.png?v=1715706345',
                    'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/3_388fb02d-8c3b-4e37-96a2-ed4a002c0ac5.png?v=1715706346',
                    'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/4_bea88dc1-f447-4627-90d2-b65b36d91aa6.png?v=1715706345',
                    'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/3_388fb02d-8c3b-4e37-96a2-ed4a002c0ac5.png?v=1715706346',
                    'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/4_bea88dc1-f447-4627-90d2-b65b36d91aa6.png?v=1715706345',
                    'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/3_388fb02d-8c3b-4e37-96a2-ed4a002c0ac5.png?v=1715706346',
                    'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/4_bea88dc1-f447-4627-90d2-b65b36d91aa6.png?v=1715706345',
                    'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/3_388fb02d-8c3b-4e37-96a2-ed4a002c0ac5.png?v=1715706346',
                    'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/4_bea88dc1-f447-4627-90d2-b65b36d91aa6.png?v=1715706345',
                  ];
                  return (
                    <div key={index} className="gifting-image-container-summary">
                      <img
                        src={placeholderUrls[index]}
                        alt="Placeholder"
                        className="gift-image-bottom-summary gift-image-in-summary-container"
                      />
                    </div>
                  );
                })}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            style={{ width: '12px' }}
          >
            <path d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z" />
          </svg>

          {giftingCart?.boxGift !== undefined && giftingCart?.boxGift?.length > 0 ? (
            giftingCart.boxGift?.map((boxGift, index) => {
              let boxProduct = null;
              if (productData) {
                for (const productArray of productData) {
                  boxProduct = productArray.find((product) => product.id === boxGift.productId);
                  if (boxProduct) {
                    break;
                  }
                }
              }

              return (
                <div
                  className="image-wrapper"
                  onClick={() => handleRemoveProduct(index, 'boxGift')}
                >
                  <div className="gifting-image-container-summary">
                    <img
                      src={boxProduct?.image?.src}
                      alt="Placeholder"
                      className="gift-image-bottom-summary gift-image-in-summary-container"
                    />
                  </div>
                  <div className="remove-overlay">REMOVE</div>
                </div>
              );
            })
          ) : (
            <div className="gifting-image-container-summary">
              <img
                src="https://cdn.shopify.com/s/files/1/0605/5100/4348/files/7.png?v=1716438789"
                alt="Placeholder"
                className="gift-image-bottom-summary gift-image-in-summary-container"
              />
            </div>
          )}
          {giftingCart?.wrappingGift !== undefined && giftingCart?.wrappingGift?.length > 0 ? (
            giftingCart.wrappingGift?.map((wrappingGift, index) => {
              let wrappingProduct = null;
              let wrappingImage = null;

              // Find the wrapping product
              for (const productArray of productData) {
                wrappingProduct = productArray.find((product) =>
                  product.variants?.some((variant) => variant.id === wrappingGift.variantId),
                );

                if (wrappingProduct) {
                  wrappingProduct = wrappingProduct?.variants?.find(
                    (variant) => variant.id === wrappingGift.variantId,
                  );
                  break;
                }
              }

              // Find the wrapping image
              if (wrappingProduct) {
                for (const productArray of productData) {
                  for (const product of productArray) {
                    wrappingImage = product.images?.find(
                      (image) => image.id === wrappingProduct.image_id,
                    );
                    if (wrappingImage) {
                      break;
                    }
                  }
                  if (wrappingImage) {
                    break;
                  }
                }
              }

              return (
                <div
                  className="image-wrapper"
                  onClick={() => handleRemoveProduct(index, 'wrappingGift')}
                >
                  <div key={wrappingProduct?.id} className="gifting-image-container-summary">
                    <img
                      src={wrappingImage?.src}
                      alt={wrappingProduct?.title}
                      className="gift-image-bottom-summary gift-image-in-summary-container"
                    />
                  </div>
                  <div className="remove-overlay">REMOVE</div>
                </div>
              );
            })
          ) : (
            <div className="gifting-image-container-summary">
              <img
                src="https://cdn.shopify.com/s/files/1/0605/5100/4348/files/6.png?v=1716438788"
                alt="Placeholder"
                className="gift-image-bottom-summary gift-image-in-summary-container"
              />
            </div>
          )}

          {giftingCart?.wishCardGift !== undefined && giftingCart?.wishCardGift?.length > 0 ? (
            giftingCart.wishCardGift?.map((wishCardGift, index) => {
              let wishcardProductImage = null;

              // Check if variantId exists and is a number
              const variantId = wishCardGift.variantId;

              if (variantId !== undefined) {
                // Iterate through productData to find the matching image
                if (productData) {
                  for (const productArray of productData) {
                    for (const product of productArray) {
                      wishcardProductImage = product.images?.find((image) =>
                        image.variant_ids?.includes(variantId as any),
                      );
                      if (wishcardProductImage) {
                        break;
                      }
                    }
                    if (wishcardProductImage) {
                      break;
                    }
                  }
                }
              }
              return (
                <div
                  className="image-wrapper"
                  onClick={() => handleRemoveProduct(index, 'wishCardGift')}
                >
                  <div key={wishcardProductImage?.id} className="gifting-image-container-summary">
                    <img
                      src={wishcardProductImage?.src}
                      className="gift-image-bottom-summary gift-image-in-summary-container"
                    />
                  </div>
                  <div className="remove-overlay">REMOVE</div>
                </div>
              );
            })
          ) : (
            <div className="gifting-image-container-summary">
              <img
                src="https://cdn.shopify.com/s/files/1/0605/5100/4348/files/5.png?v=1716438788"
                alt="Placeholder"
                className="gift-image-bottom-summary gift-image-in-summary-container"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const ReviewGiftBoxPage: React.FC<ReviewGiftBoxProps> = ({
  productData,
  onBack,
  onGiftChange,
  giftingCart,
  onHandleGiftingCart,
  totalPrice,
  minSpend,
  discountAmount,
  discountType,
  productTitle,
  setPopupData,
  popupData,
  cartLoading,
  setCartLoading,
  giftingCategory,
  setCurrentPage,
}) => {
  const [newTotalPrice, setNewTotalPrice] = useState(0);
  const [messageDiscount, setMessageDiscount] = useState<string | null>(null);
  const [discount, setDiscount] = useState(0);
  const handleGiftCart = () => {
    onHandleGiftingCart();
  };
  useEffect(() => {
    const allGifts = [
      ...(giftingCart.mainGift ? giftingCart.mainGift.filter((item) => item != null) : []),
      ...(giftingCart.accessoriesGift
        ? giftingCart.accessoriesGift.filter((item) => item != null)
        : []),
      ...(giftingCart.wishCardGift ? giftingCart.wishCardGift.filter((item) => item != null) : []),
      ...(giftingCart.boxGift ? giftingCart.boxGift.filter((item) => item != null) : []),
      ...(giftingCart.wrappingGift ? giftingCart.wrappingGift.filter((item) => item != null) : []),
    ];
    if (allGifts.length === productData.length) {
      if (totalPrice > minSpend) {
        let newTotal = 0;
        if (discountType === 'fixedOff') {
          newTotal = totalPrice - discountAmount;

          setDiscount(discountAmount);
          setNewTotalPrice(newTotal);
        } else {
          const newTotal = totalPrice - (discountAmount / 100) * totalPrice;
          setDiscount((discountAmount / 100) * totalPrice);
          setNewTotalPrice(newTotal);
        }
      } else {
        setNewTotalPrice(totalPrice);
      }
    } else {
      setMessageDiscount('Please select all product to get the discount');
      setNewTotalPrice(totalPrice);
    }
  }, [totalPrice]);

  const handleClosePopup = () => {
    setPopupData(null);
  };

  const handleBoxReviewImageClick = (type: string) => {
    console.log({ type });
    if (type === 'mainProduct') {
      setCurrentPage(1);
    } else if (type === 'accessoriesProduct') {
      setCurrentPage(1);
    } else if (type === 'boxProduct') {
      setCurrentPage(2);
    } else if (type === 'wishCardProduct') {
      setCurrentPage(3);
    } else if (type === 'wrappingProduct') {
      setCurrentPage(2);
    }
  };
  return (
    <div className="container">
      <div className="box-button-container">
        <button onClick={onBack}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            style={{ width: '20px' }}
          >
            <path
              fill-rule="evenodd"
              d="M11.78 5.22a.75.75 0 0 1 0 1.06L8.06 10l3.72 3.72a.75.75 0 1 1-1.06 1.06l-4.25-4.25a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z"
              clip-rule="evenodd"
            />
          </svg>
          Add a Personal Message
        </button>
      </div>
      <div className="gifting-selected-product-container review-container">
        <div className="left">
          <h1>Let's Review Your Gift Box</h1>
          <p>Your gift box is ready to be wrapped up!</p>
          <div className="gift-item-summary-container">
            {giftingCart.mainGift?.map((mainGift, index) => {
              let mainProduct = {} as GiftingProduct;
              productData.map((product) => {
                product.map((p) => {
                  if (p.id === mainGift?.productId) {
                    mainProduct = p;
                  }
                });
              });
              const mainProductImage = mainProduct?.images?.find((image) =>
                image.variant_ids?.find((variant) => variant === mainGift.variantId),
              );

              return (
                <div key={index} className="gift-summary-image-container" style={{}}>
                  {mainProductImage?.src !== undefined ? (
                    <img
                      onClick={() => handleBoxReviewImageClick('mainProduct')}
                      src={mainProductImage?.src}
                      alt={mainProductImage?.src}
                      className="gift-summary-image"
                      style={{ cursor: 'pointer' }}
                    />
                  ) : (
                    <img
                      onClick={() => handleBoxReviewImageClick('mainProduct')}
                      src={mainProduct?.image?.src}
                      alt={mainProduct?.image?.src}
                      className="gift-summary-image"
                      style={{ cursor: 'pointer' }}
                    />
                  )}
                </div>
              );
            })}
            {giftingCart.accessoriesGift?.map((accessoriesGift, index) => {
              let accessoriesProduct = {} as GiftingProduct;
              productData?.map((product) => {
                product.map((p) => {
                  if (p.id === accessoriesGift?.productId) {
                    accessoriesProduct = p;
                  }
                });
              });
              let accessoriesProductImage = {} as any;
              accessoriesProductImage = accessoriesProduct?.images?.find((image) =>
                image.variant_ids?.find((variant) => variant === accessoriesGift?.variantId),
              );

              return (
                <div key={index} className="gift-summary-image-container">
                  {accessoriesProductImage?.src !== undefined ? (
                    <img
                      onClick={() => handleBoxReviewImageClick('accessoriesProduct')}
                      src={
                        accessoriesProductImage?.src !== undefined
                          ? accessoriesProductImage?.src
                          : accessoriesProduct?.image?.src
                      }
                      alt={
                        accessoriesProductImage?.src !== undefined
                          ? accessoriesProductImage?.src
                          : accessoriesProduct?.image?.src
                      }
                      className="gift-summary-image"
                      style={{ cursor: 'pointer' }}
                    />
                  ) : (
                    <img
                      onClick={() => handleBoxReviewImageClick('accessoriesProduct')}
                      style={{ cursor: 'pointer' }}
                      src={accessoriesProduct?.image?.src}
                      alt={accessoriesProduct?.image?.src}
                      className="gift-summary-image"
                    />
                  )}
                </div>
              );
            })}
          </div>
          <div className="flex" style={{ gap: '3px' }}>
            {giftingCart.boxGift?.map((boxGift) => {
              let boxProduct = null;

              // Iterate through productData to find the matching product
              if (productData) {
                for (const productArray of productData) {
                  boxProduct = productArray.find((product) => product.id === boxGift.productId);
                  if (boxProduct) {
                    break;
                  }
                }
              }

              return (
                <div key={boxProduct?.id} className="personalized-item-container">
                  <img
                    onClick={() => handleBoxReviewImageClick('boxProduct')}
                    style={{ cursor: 'pointer' }}
                    src={boxProduct?.image?.src}
                    alt={boxProduct?.title}
                    className="gift-summary-image"
                  />
                </div>
              );
            })}
            {giftingCart.wrappingGift?.map((wrappingGift) => {
              let wrappingProduct = null;
              let wrappingImage = null;

              // Find the wrapping product
              for (const productArray of productData) {
                wrappingProduct = productArray.find((product) =>
                  product.variants?.some((variant) => variant.id === wrappingGift.variantId),
                );

                if (wrappingProduct) {
                  wrappingProduct = wrappingProduct?.variants?.find(
                    (variant) => variant.id === wrappingGift.variantId,
                  );
                  break;
                }
              }

              // Find the wrapping image
              if (wrappingProduct) {
                for (const productArray of productData) {
                  for (const product of productArray) {
                    wrappingImage = product.images?.find(
                      (image) => image.id === wrappingProduct.image_id,
                    );
                    if (wrappingImage) {
                      break;
                    }
                  }
                  if (wrappingImage) {
                    break;
                  }
                }
              }

              return (
                <div key={wrappingProduct?.id} className="personalized-item-container">
                  <img
                    onClick={() => handleBoxReviewImageClick('wrappingProduct')}
                    style={{ cursor: 'pointer' }}
                    src={wrappingImage?.src}
                    alt={wrappingProduct?.title}
                    className="gift-summary-image"
                  />
                </div>
              );
            })}
            {giftingCart.wishCardGift?.map((wishCardGift) => {
              let wishcardProductImage = null;

              // Check if variantId exists and is a number
              const variantId = wishCardGift.variantId;

              if (variantId !== undefined) {
                // Iterate through productData to find the matching image
                if (productData) {
                  for (const productArray of productData) {
                    for (const product of productArray) {
                      wishcardProductImage = product.images?.find((image) =>
                        image.variant_ids?.includes(variantId as any),
                      );
                      if (wishcardProductImage) {
                        break;
                      }
                    }
                    if (wishcardProductImage) {
                      break;
                    }
                  }
                }
              }
              return (
                <div key={wishcardProductImage?.id} className="personalized-item-container">
                  <img
                    onClick={() => handleBoxReviewImageClick('wishCardProduct')}
                    style={{ cursor: 'pointer' }}
                    src={wishcardProductImage?.src}
                    className="gift-summary-image"
                  />
                </div>
              );
            })}
          </div>
        </div>
        <div className="right">
          <div className="gifting-box-content-summary flex flex-col justify-between">
            <div>
              <h4>Box Contents</h4>
              <hr />
              <div className="summary-gift-items">
                <h6 className="no-mb">Main Product </h6>
                <p className="no-mb" style={{ textAlign: 'right' }}>
                  {giftingCart.mainGift?.length
                    ? giftingCart.mainGift.map((mainGift, index) => {
                        let mainProduct = {} as any;
                        productData.map((product, index) =>
                          product.map((p, i) => {
                            if (p.id === mainGift.productId) {
                              mainProduct = p;
                            }
                          }),
                        );
                        return (
                          <React.Fragment key={index}>
                            {mainProduct?.title}
                            <br />
                            RM {mainProduct?.variants?.[0]?.price}
                            <br />
                          </React.Fragment>
                        );
                      })
                    : '-'}
                </p>
              </div>
              <hr />
              <div className="summary-gift-items">
                <h6 className="no-mb">Accessories Product </h6>
                <p className="no-mb" style={{ textAlign: 'right' }}>
                  {giftingCart.accessoriesGift?.length
                    ? giftingCart.accessoriesGift.map((accessoriesGift, index) => {
                        let accessoriesProduct = {} as any;
                        productData.map((product, index) =>
                          product.map((p, i) => {
                            if (p.id === accessoriesGift.productId) {
                              accessoriesProduct = p;
                            }
                          }),
                        );
                        return (
                          <React.Fragment key={index}>
                            {accessoriesProduct?.title}
                            <br />
                            RM {accessoriesProduct?.variants?.[0]?.price}
                            <br />
                          </React.Fragment>
                        );
                      })
                    : '-'}
                </p>
              </div>
              <hr />
              <div className="summary-gift-items">
                <h6 className="no-mb">Gift Box</h6>
                <p className="no-mb" style={{ textAlign: 'right' }}>
                  {giftingCart.boxGift?.length
                    ? giftingCart.boxGift.map((boxGift, index) => {
                        let boxProduct = {} as any;
                        productData.map((product, index) =>
                          product.map((p, i) => {
                            if (p.id === boxGift.productId) {
                              boxProduct = p;
                            }
                          }),
                        );
                        return (
                          <React.Fragment key={index}>
                            {boxProduct?.title}
                            <br />
                            RM {boxProduct?.variants?.[0]?.price}
                            <br />
                          </React.Fragment>
                        );
                      })
                    : '-'}
                </p>
              </div>
              <hr />
              <div className="summary-gift-items">
                <h6 className="no-mb">Gift Wrap</h6>
                <p className="no-mb" style={{ textAlign: 'right' }}>
                  {giftingCart.wrappingGift?.length
                    ? giftingCart.wrappingGift.map((wrappingGift, index) => {
                        let wrappingProduct = {} as any;
                        productData?.map((product, index) =>
                          product.map((p, i) => {
                            p.variants?.map((variant, variantIndex) => {
                              if (variant.id === wrappingGift.variantId) {
                                wrappingProduct = variant;
                              }
                            });
                          }),
                        );
                        return (
                          <React.Fragment key={index}>
                            {wrappingProduct?.title}
                            <br />
                            RM {wrappingProduct?.price}
                            <br />
                          </React.Fragment>
                        );
                      })
                    : '-'}
                </p>
              </div>
              <hr />
              <div className="summary-gift-items">
                <h6 className="no-mb">Wish Card</h6>
                <p className="no-mb" style={{ textAlign: 'right' }}>
                  {giftingCart.wishCardGift?.length
                    ? giftingCart.wishCardGift.map((wishCard, index) => {
                        let wishcardProduct = {} as any;
                        productData?.map((product, index) =>
                          product.map((p, i) => {
                            p.variants?.map((variant, variantIndex) => {
                              if (variant.id === wishCard.variantId) {
                                wishcardProduct = variant;
                              }
                            });
                          }),
                        );
                        return (
                          <React.Fragment key={index}>
                            {wishcardProduct?.title}
                            <br />
                            {wishcardProduct?.price === '0.00' ||
                            wishcardProduct?.price === undefined
                              ? 'FREE!'
                              : 'RM ' + wishcardProduct?.price}
                            <br />
                          </React.Fragment>
                        );
                      })
                    : '-'}
                </p>
              </div>
              <hr />
              <div className="summary-gift-items">
                <h6 className="no-mb">Recipient's Name</h6>
                <p className="no-mb" style={{ textAlign: 'right' }}>
                  {giftingCart.wishCardGift?.length
                    ? giftingCart.wishCardGift.map((wishCard, index) => (
                        <React.Fragment key={index}>
                          {wishCard.recipientName ? wishCard.recipientName : '-'}
                          <br />
                        </React.Fragment>
                      ))
                    : '-'}
                </p>
              </div>
              <hr />
              <div>
                <h6>Message</h6>
                {giftingCart.wishCardGift?.length
                  ? giftingCart.wishCardGift.map((wishCard, index) => (
                      <React.Fragment key={index}>
                        <p className="no-mb">{wishCard.message ? wishCard.message : '-'}</p>
                        <br />
                      </React.Fragment>
                    ))
                  : '-'}
              </div>
              <hr />
              {totalPrice >= minSpend && messageDiscount === null ? (
                <div>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <h4 className="gifting-subtotal-product-price">Subtotal</h4>
                    <h4 className="gifting-subtotal-product-price">RM {totalPrice.toFixed(2)}</h4>
                  </div>
                  {discount.toString() === '0' ? null : (
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <h4 className="gifting-subtotal-product-price">Discount</h4>
                      <h4 className="gifting-subtotal-product-price">RM {discount}</h4>
                    </div>
                  )}
                </div>
              ) : (
                <>
                  <p
                    className="gifting-subtotal-product-price blinking-text"
                    style={{ color: '#6f1920' }}
                  >
                    {messageDiscount === null
                      ? `Add RM${(minSpend - totalPrice).toFixed(
                          2,
                        )} more to get RM${discountAmount} off`
                      : messageDiscount}
                  </p>
                </>
              )}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginTop: '2rem',
                }}
              >
                <h4 className="gifting-total-product-price">Total</h4>
                <h4 className="gifting-total-product-price">RM {newTotalPrice.toFixed(2)}</h4>
              </div>
            </div>
          </div>

          {popupData && (
            <Popup data={popupData} popupTitle={productTitle} onClose={handleClosePopup} />
          )}
          <button onClick={handleGiftCart} className="button-next-page">
            Box it up!
          </button>
        </div>
      </div>
    </div>
  );
};

interface Props {
  productTitle: string;
  cartIconClass: string | undefined;
  productColourSwatches: string[];
  shopCurrency: string;
}
interface Gifting {
  combo_products: string[];
  id: string;
  discountAmount: string;
  discountType: string;
  type: string;
  price: string;
  minSpend: string;
  title: string;
  giftingCategory: {
    [index: number]: string;
  }[];
  imageLink?: string;
}
const GiftingModule = (props: Props) => {
  const { cartIconClass, productColourSwatches, productTitle, shopCurrency } = props;
  const [comboId, setComboId] = useState(`COMBO${(Math.random() * 10000).toFixed(0)}`);
  const [selectedOptions, setSelectedOptions] = useState<{ [index: number]: SelectedOption }>({});
  const [personalisationId, setPersonalisationId] = useState((Math.random() * 10000).toFixed(0));
  const [cartLoading, setCartLoading] = useState(false);
  const [totalPrice, setTotalPrice] = useState(0);
  const [selectedProductChoices, setSelectedProductChoices] = useState<any[]>([]);
  const [products, setProducts] = useState<GiftingProduct[][]>([]);
  const [giftingCart, setGiftingCart] = useState<CartGifting>({});
  const [popupData, setPopupData] = useState(null);
  const [busy, setBusy] = useState(false);
  const [recipientName, setRecipientName] = useState('');
  const [minSpend, setMinSpend] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [discountType, setyDiscountType] = useState('');
  const [giftingCategory, setGiftingCategory] = useState<GiftingCategory[]>([]);
  const [message, setMessage] = useState('');
  const [giftId, setGiftId] = useState('');
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [giftingData, setGiftingData] = useState<Gifting[]>([]);
  const [giftParams, setGiftParams] = useState('');
  const [currentPage, setCurrentPage] = useState<number>(1);
  useEffect(() => {
    const pathSegments = window.location.pathname.split('/');
    const lastSegment = pathSegments[pathSegments.length - 1];
    if (lastSegment !== 'customize-your-own-gift') {
      if (lastSegment === 'customize_gift_telekung') {
        setGiftParams('8480586399932');
        setGiftId('8480586399932');
      } else if (lastSegment === 'customize_gift_for_her') {
        setGiftParams('8480656228540');
        setGiftId('8480656228540');
      } else if (lastSegment === 'customize_gift_for_him') {
        setGiftParams('8480706199740');
        setGiftId('8480706199740');
      }
      setCurrentPage(1);
    }
  }, [giftId]);

  // fetch list gifting combo from api
  useEffect(() => {
    const fetchGifting = async () => {
      try {
        const response = await fetch(`${api}/getGifting`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();

        setGiftingData(data.giftingArray);
      } catch (error: any) {
        console.error('Fetch error:', error.message);
      }
    };

    fetchGifting();
  }, []);

  useEffect(() => {
    // fetch product
    setCartLoading(true);
    const fetchComboProducts = async (giftParams: string) => {
      if (giftParams !== '') {
        const response = await fetch(`${api}/getComboProducts?id=${giftParams}&shop=${shop}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });
        const data = await response.json();
        if (data && data.products) {
          setProducts(data.products);
          setMinSpend(data.minSpend);
          setDiscountAmount(data.discountAmount);
          setyDiscountType(data.discountType);
          setGiftingCategory(data.gifting_category);
          // Initialize with `null` instead of `0`
          const initialSelectedProductChoices = new Array(data.products.length).fill(null);
          setSelectedProductChoices(initialSelectedProductChoices);
        } else {
          setProducts([]);
        }
      }
      setCartLoading(false);
    };
    fetchComboProducts(giftParams);
  }, [giftId, giftParams]);

  useEffect(() => {
    const allGifts = [
      ...(giftingCart.mainGift || []),
      ...(giftingCart.accessoriesGift || []),
      ...(giftingCart.wishCardGift || []),
      ...(giftingCart.boxGift || []),
      ...(giftingCart.wrappingGift || []),
    ];
    let totalPrice = 0;
    allGifts.forEach((allgift) => {
      products.some((product) => {
        const productExist = product.find((p) => p.id === allgift?.productId);
        const variantExist = productExist?.variants?.find(
          (variant) => variant.id === allgift.variantId,
        );

        if (variantExist) {
          totalPrice += parseFloat(variantExist.price);
          return true; // Exit the 'some' loop once the product is found
        }

        return false;
      });
    });
    setTotalPrice(totalPrice);
  }, [giftingCart]);

  useEffect(() => {
    setCartLoading(true);
    const giftingCategoryAccessoriesSlice = giftingCategory.filter(
      (gc) => gc === 'accessoriesProduct',
    );

    const filledAccessories: { variantId: number; productId: number | undefined }[] = new Array( // set array of selectedCombo Product based on product length
      giftingCategoryAccessoriesSlice.length,
    ).fill(null);
    (giftingCart.accessoriesGift as any) = filledAccessories;

    const giftingCategoryMainProductSlice = giftingCategory.filter((gc) => gc === 'mainProduct');

    const filledMainProduct: { variantId: number; productId: number | undefined }[] = new Array( // set array of selectedCombo Product based on product length
      giftingCategoryMainProductSlice.length,
    ).fill(null);
    (giftingCart.mainGift as any) = filledMainProduct;
    setCartLoading(false);
  }, [products, giftingCategory]);

  useEffect(() => {
    if (currentPage === 0) {
      setGiftId('');
      setProducts([]);
      setMinSpend(0);
      setDiscountAmount(0);
      setyDiscountType('');
      setProducts([]);
      setGiftingCart({});
      setGiftingCategory([]);
    }
  }, [currentPage]);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    // Clean up the event listener
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);

  const handleGiftChange = (
    variantId: number,
    productId: number | undefined,
    type: GiftType,
    index: number,
  ) => {
    if (type === 'mainGift') {
      setGiftingCart((prev) => {
        const gift = [...((prev[type] as any) || [])];
        const newGift = {
          ...gift[index],
          variantId: variantId,
          productId: productId,
        };
        gift.splice(index, 1, newGift);
        const output = {
          ...prev,
          [type]: gift,
        };
        return output;
      });
    } else if (type === 'accessoriesGift') {
      const filterMainProduct = giftingCategory.filter((gc) => gc === 'mainProduct');
      let newIndex = 0;
      let emptyIndex = 0 as any;
      emptyIndex = giftingCart?.accessoriesGift?.findIndex(
        (e) => (e?.productId as any) === undefined || (e?.productId as any) === null,
      );
      if (emptyIndex === -1) {
        emptyIndex = 0;
      }
      if (filterMainProduct.length > 1) {
        newIndex = (emptyIndex as any) + 1;
      } else {
        newIndex = index;
      }
      setGiftingCart((prev) => {
        const gift = [...((prev[type] as any) || [])];
        const newGift = {
          ...gift[newIndex - 1],
          variantId: variantId,
          productId: productId,
        };
        gift.splice(newIndex - 1, 1, newGift);
        const output = {
          ...prev,
          [type]: gift,
        };
        return output;
      });
    } else if (type === 'wishCardGift') {
      if (giftingCart.wishCardGift?.length !== 1) {
        setGiftingCart((prev) => ({
          ...prev,
          [type]: [
            ...(prev[type] || []),
            {
              variantId: variantId,
              productId: productId,
              message: message,
              recipientName: recipientName,
            },
          ],
        }));
      } else {
        setGiftingCart((prev) => ({
          ...prev,
          [type]: [
            {
              variantId: variantId,
              productId: productId,
              message: message,
              recipientName: recipientName,
            },
          ],
        }));
      }
    } else if (type === 'boxGift') {
      if (giftingCart.boxGift?.length !== 1) {
        setGiftingCart((prev) => ({
          ...prev,
          [type]: [
            ...(prev[type] || []),
            {
              variantId: variantId,
              productId: productId,
            },
          ],
        }));
      } else {
        setGiftingCart((prev) => ({
          ...prev,
          [type]: [
            {
              variantId: variantId,
              productId: productId,
            },
          ],
        }));
      }
    } else if (type === 'wrappingGift') {
      if (giftingCart.wrappingGift?.length !== 1) {
        setGiftingCart((prev) => ({
          ...prev,
          [type]: [
            ...(prev[type] || []),
            {
              variantId: variantId,
              productId: productId,
            },
          ],
        }));
      } else {
        setGiftingCart((prev) => ({
          ...prev,
          [type]: [
            {
              variantId: variantId,
              productId: productId,
            },
          ],
        }));
      }
    }
  };
  const onNextStep = (giftId: string) => {
    if (giftId === '8480586399932') {
      window.history.pushState({}, '', `/pages/customize-your-own-gift/customize_gift_telekung`);
    } else if (giftId === '8480656228540') {
      window.history.pushState({}, '', `/pages/customize-your-own-gift/customize_gift_for_her`);
    } else if (giftId === '8480706199740') {
      window.history.pushState({}, '', `/pages/customize-your-own-gift/customize_gift_for_him`);
    }
    setGiftId(giftId);
    if (busy === false) {
      setCurrentPage(currentPage + 1);
    }
  };
  const handleBack = () => {
    setCurrentPage(currentPage - 1);
  };
  const handleNext = () => {
    setCurrentPage(currentPage + 1);
  };
  const handleChangeRecipientName = (e: any) => {
    setRecipientName(e.target.value);
    if (giftingCart.wishCardGift?.length !== 1) {
      setGiftingCart((prev) => ({
        ...prev,
        wishCardGift: [
          ...(prev['wishCardGift'] || []),
          {
            message: '',
            recipientName: e.target.value,
          },
        ],
      }));
    } else {
      setGiftingCart((prev) => ({
        ...prev,
        wishCardGift: [
          {
            ...(prev['wishCardGift']?.[0] || []),
            message: message,
            recipientName: e.target.value,
          },
        ],
      }));
    }
  };
  const handleChangeMessage = (e: any) => {
    if (e.target.value !== 'on') {
      setMessage(e.target.value.slice(0, 100));
      if (giftingCart.wishCardGift?.length !== 1) {
        setGiftingCart((prev) => ({
          ...prev,
          wishCardGift: [
            ...(prev['wishCardGift'] || []),
            {
              recipientName: recipientName,
              message: '',
            },
          ],
        }));
      } else {
        setGiftingCart((prev) => ({
          ...prev,
          wishCardGift: [
            {
              ...(prev['wishCardGift']?.[0] || []),
              recipientName: recipientName,
              message: e.target.value.slice(0, 100),
            },
          ],
        }));
      }
    } else {
      setMessage('');
      if (giftingCart.wishCardGift?.length !== 1) {
        setGiftingCart((prev) => ({
          ...prev,
          wishCardGift: [
            ...(prev['wishCardGift'] || []),
            {
              recipientName: recipientName,
              message: '',
            },
          ],
        }));
      } else {
        setGiftingCart((prev) => ({
          ...prev,
          wishCardGift: [
            {
              ...(prev['wishCardGift']?.[0] || []),
              recipientName: recipientName,
              message: '',
            },
          ],
        }));
      }
    }
  };
  const handleAddToCart = async () => {
    setCartLoading(true);

    const allGifts = [
      ...(giftingCart.mainGift || []),
      ...(giftingCart.accessoriesGift || []),
      // ...(giftingCart.wishCardGift || []),
      ...(giftingCart.boxGift || []),
      ...(giftingCart.wrappingGift || []),
    ];
    try {
      const wishCardProduct = giftingCart?.wishCardGift
        ?.map((product, index) => {
          if (!product) return null;
          const customProperties = { 'Wish Text': product.message }; //  { 0: { 'Wish Text': 'hello' } }
          return {
            id: product!.variantId,
            quantity: 1,
            properties: customProperties
              ? {
                  Personalisation: personalisationId,
                  Addon: 'Yes',
                  _combo_id: giftId,
                  Combo: comboId,
                  'Combo Name': 'Custom Gifting',
                  ...customProperties,
                }
              : {
                  Personalisation: personalisationId,
                  Addon: 'Yes',
                },
          };
        })
        .filter((product) => product !== null);

      const items = [...(wishCardProduct as any)];
      const response = await fetch(`/cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: allGifts
            .filter((e) => e)
            .map((product) => ({
              id: product.variantId,
              quantity: 1,
              properties: {
                _combo_id: giftId,
                Combo: comboId,
                'Combo Name': 'Custom Gifting',
              },
            }))
            .concat(items),
          // sections: 'cart-items,cart-icon-bubble,cart-live-region-text,cart-footer',
        }),
      });
      setComboId(`COMBO${(Math.random() * 10000).toFixed(0)}`);
      const data = await response.json();
      // todo popup added items to cart
      setPopupData(data);
      const cart = await fetchCart();
      updateIconCount(cart, cartIconClass);
    } catch (err) {
      console.log('*err*', err);
    } finally {
      setPersonalisationId((Math.random() * 10000).toFixed(0));
      setCartLoading(false);
    }
  };

  const giftOptions = [
    {
      title: 'Gift 1',
      description: '1 main product + 3 accessories + wish card + box + wrapping',
      discountType: 'Get RM30 off with min spend of RM300',
      images: [
        'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/1_8652a78a-7268-4964-a090-b5cc8894e4a7.png?v=1715706345',
        'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/2_685be79b-3fd7-4c5e-9f58-7ce9a6db1b4f.png?v=1715706345',
        'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/3_388fb02d-8c3b-4e37-96a2-ed4a002c0ac5.png?v=1715706346',
        'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/4_bea88dc1-f447-4627-90d2-b65b36d91aa6.png?v=1715706345',
        'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/5.png?v=1716438788',
        'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/6.png?v=1716438788',
        'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/7.png?v=1716438789',
      ],
    },
    {
      title: 'Gift 2',
      description: '2 main products + 1 accessory + wish card + box + wrapping',
      discountType: 'Get RM50 off with min spend of RM500',
      images: [
        'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/1_8652a78a-7268-4964-a090-b5cc8894e4a7.png?v=1715706345',
        'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/1_8652a78a-7268-4964-a090-b5cc8894e4a7.png?v=1715706345',
        'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/3_388fb02d-8c3b-4e37-96a2-ed4a002c0ac5.png?v=1715706346',
        'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/5.png?v=1716438788',
        'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/6.png?v=1716438788',
        'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/7.png?v=1716438789',
      ],
    },
    {
      title: 'Gift 3',
      description: '3 main products + 2 accessories + wish card + box + wrapping',
      discountType: 'Get RM100 off with min spend of RM1000',
      images: [
        'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/1_8652a78a-7268-4964-a090-b5cc8894e4a7.png?v=1715706345',
        'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/1_8652a78a-7268-4964-a090-b5cc8894e4a7.png?v=1715706345',
        'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/1_8652a78a-7268-4964-a090-b5cc8894e4a7.png?v=1715706345',
        'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/4_bea88dc1-f447-4627-90d2-b65b36d91aa6.png?v=1715706345',
        'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/4_bea88dc1-f447-4627-90d2-b65b36d91aa6.png?v=1715706345',
        'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/5.png?v=1716438788',
        'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/6.png?v=1716438788',
        'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/7.png?v=1716438789',
      ],
    },
  ];
  const mainProductImagePlaceholders = [
    'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/1_8652a78a-7268-4964-a090-b5cc8894e4a7.png?v=1715706345',
  ];
  const accessoriesImagePlaceholders = [
    'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/2_685be79b-3fd7-4c5e-9f58-7ce9a6db1b4f.png?v=1715706345',
    'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/3_388fb02d-8c3b-4e37-96a2-ed4a002c0ac5.png?v=1715706346',
    'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/4_bea88dc1-f447-4627-90d2-b65b36d91aa6.png?v=1715706345',
    'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/2_685be79b-3fd7-4c5e-9f58-7ce9a6db1b4f.png?v=1715706345',
    'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/3_388fb02d-8c3b-4e37-96a2-ed4a002c0ac5.png?v=1715706346',
    'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/4_bea88dc1-f447-4627-90d2-b65b36d91aa6.png?v=1715706345',
  ];
  const wishCardImagPlaceholders = [
    'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/5.png?v=1716438788',
  ];
  const boxImagePlaceholders = [
    'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/6.png?v=1716438788',
  ];
  const wrappingImagePlaceholders = [
    'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/7.png?v=1716438789',
  ];
  const forHer =
    'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/GIFTING_PAGE-_FOR_HER.jpg?v=1720750558';
  const forHim =
    'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/GIFTING_PAGE-_FOR_HIM.jpg?v=1720750558';
  const telekungPackage =
    'https://cdn.shopify.com/s/files/1/0605/5100/4348/files/GIFTING_PAGE-_TELEKUNG.jpg?v=1720750557';

  let pageContent;
  switch (currentPage) {
    case 0: // Landing Page
      pageContent = (
        <div className="container" style={{ paddingRight: '0px', paddingLeft: '0px' }}>
          <div className="gifting-selected-product-container">
            <div>
              {windowWidth >= 1200 ? (
                <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                  {/* <div style={{ flex: '1', padding: '0 20px', maxWidth: '50%' }}>
                                        <h1 style={{ fontSize: '2rem', marginBottom: '10px' }}>Build Your Own Gift</h1>
                                        <p style={{ fontSize: '1.2rem' }}>
                                            Start with a gift set and handpick the perfect items inside for a truly personalized present.
                                        </p>
                                    </div> */}
                  <img
                    style={{ height: 'auto', width: '100%', maxWidth: '100%' }}
                    src="https://cdn.shopify.com/s/files/1/0605/5100/4348/files/GIFTING_BANNER-DESKTOP_1.jpg?v=1720750558"
                    alt="Gift"
                    className="align-top mr-5"
                  />
                </div>
              ) : (
                <div style={{ textAlign: 'center' }}>
                  <img
                    style={{ width: '100%', height: 'auto' }}
                    src="https://cdn.shopify.com/s/files/1/0605/5100/4348/files/GIFTING_BANNER-MOBILE_1.jpg?v=1720750690"
                    alt="Gift"
                    className="align-top mr-5"
                  />
                  {/* <div style={{ padding: '20px' } }>
                                        <h1 style={{ fontSize: '1.5rem', marginBottom: '10px' }}>Build Your Own Gift</h1>
                                        <p style={{ fontSize: '1rem' }}>
                                            Start with a gift set and handpick the perfect items inside for a truly personalized present.
                                        </p>
                                    </div> */}
                </div>
              )}
              <div
                className="gift-set-button-container"
                style={{ display: windowWidth >= 1200 ? 'flex' : 'grid' }}
              >
                {giftingData.map((gift, index) => (
                  <div key={index} className="gift-set-option" onClick={() => onNextStep(gift.id)}>
                    <div className="gift-set-option-item">
                      <div>
                        <div className="gift-set-images">
                          {/* {gift.combo_products.map(
                                                        (comboProduct, imgIndex) => {
                                                            return (
                                                                <React.Fragment key={imgIndex}> */}
                          <img
                            src={gift?.imageLink}
                            // src={gift.title === 'For Him' ? forHim : gift.title === 'For Her' ? forHer : gift.title === 'Telekung Gift Package' ? telekungPackage : telekungPackage}
                            className="gift-set-product-image"
                          />
                          {/* </React.Fragment>
                                                            );
                                                        },
                                                    )} */}
                        </div>
                        <br />
                        <div className="gift-set-title">
                          <h3
                            style={{
                              color: 'rgb(119 113 113)',
                              fontSize: 'medium',
                              textAlign: 'center',
                            }}
                          >
                            {gift?.title}{' '}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke-width="1.5"
                              stroke="currentColor"
                              style={{ width: '15px' }}
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="m8.25 4.5 7.5 7.5-7.5 7.5"
                              />
                            </svg>
                          </h3>
                          {gift.discountAmount === '0' ? null : (
                            <h3
                              style={{
                                fontWeight: 'bold',
                                color: 'rgb(119 113 113)',
                                fontSize: 'small',
                              }}
                            >
                              **Get {gift.discountType === 'fixedOff' ? 'RM' : null}
                              {gift.discountAmount}
                              {gift.discountType === 'percentageOff' ? '%' : null} off with min
                              spend of RM{gift.minSpend}
                            </h3>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      );
      break;
    case 1: // Choose Product Page (Main && accessories)
      pageContent = (
        <ChooseProductPage
          productData={products}
          totalPrice={totalPrice}
          onBack={handleBack}
          onNextStep={onNextStep}
          onGiftChange={handleGiftChange}
          productColourSwatches={productColourSwatches}
          giftingCart={giftingCart}
          setGiftingCart={setGiftingCart}
          shopCurrency={shopCurrency}
          giftId={giftParams}
          cartLoading={cartLoading}
          setCartLoading={setCartLoading}
          giftingCategory={giftingCategory}
          giftParams={giftParams}
        />
      );
      break;
    case 2: // Box && Wrapping Page
      pageContent = (
        <AddBoxandWrappingPage
          productData={products}
          onBack={handleBack}
          onNext={onNextStep}
          onGiftChange={handleGiftChange}
          giftingCart={giftingCart}
          giftId={giftParams}
          setGiftingCart={setGiftingCart}
          cartLoading={cartLoading}
          setCartLoading={setCartLoading}
          giftingCategory={giftingCategory}
        />
      );
      break;
    case 3: // Wish Card Page
      pageContent = (
        <AddPersonalMessagePage
          productData={products}
          onBack={handleBack}
          onNext={onNextStep}
          onGiftChange={handleGiftChange}
          giftingCart={giftingCart}
          setGiftingCart={setGiftingCart}
          onChangeRecipientName={handleChangeRecipientName}
          onChangeMessage={handleChangeMessage}
          giftId={giftParams}
          cartLoading={cartLoading}
          setCartLoading={setCartLoading}
          giftingCategory={giftingCategory}
        />
      );
      break;
    case 4: // Review Gift Page
      pageContent = (
        <ReviewGiftBoxPage
          productData={products}
          onBack={handleBack}
          onGiftChange={handleGiftChange}
          giftingCart={giftingCart}
          onHandleGiftingCart={handleAddToCart}
          totalPrice={totalPrice}
          minSpend={minSpend}
          discountAmount={discountAmount}
          discountType={discountType}
          productTitle={productTitle}
          setPopupData={setPopupData}
          popupData={popupData}
          cartLoading={cartLoading}
          setCartLoading={setCartLoading}
          giftingCategory={giftingCategory}
          setCurrentPage={setCurrentPage}
        />
      );
      break;
    default:
      pageContent = (
        <ChooseProductPage
          productData={products}
          totalPrice={totalPrice}
          onBack={handleBack}
          onNextStep={onNextStep}
          onGiftChange={handleGiftChange}
          productColourSwatches={productColourSwatches}
          giftingCart={giftingCart}
          setGiftingCart={setGiftingCart}
          shopCurrency={shopCurrency}
          giftId={giftParams}
          cartLoading={cartLoading}
          setCartLoading={setCartLoading}
          giftingCategory={giftingCategory}
          giftParams={giftParams}
        />
      );
  }

  return <div>{pageContent}</div>;
};

export default GiftingModule;
